<ngx-spinner [fullScreen]="true" type="ball-clip-rotate-multiple" size="medium">
    <p class="loading">Loading ...</p>
</ngx-spinner>





<!-- Banner -->
<section id="banner">
    <div class="inner">
        <h1>Multi-Cloud Total Cost of Ownership (TCO) Calculator</h1>
        <p style="color: white;">Estimate the cost savings you can realize by migrating your workloads to public clouds</p>
        <!--<ul class="actions">
                    <li><a href="#" class="button alt">Get Started</a></li>
                </ul> One -->
    </div>
</section>


<!-- One -->

<form class="msform" method="post">
    <!-- progressbar -->
    <ul class="progressbar">
        <li class="active">Define Workloads</li>
        <li class="active">Adjust Assumptions</li>
        <li class="active">View Report</li>
    </ul>
</form>

<!-- End Multi step form -->

<div id="ignoreContent" style='display:none;'>
    <img src="./../../../assets/images/logo_pdf.png" style="width:100px;heigth:100px" id="logo" />  
 </div>
<div  id="pdf" style="display: none;">
    <div class="p-container">
        <div class="pdfPageBreak">
        <table  border="0"  >
            <tr>
              <td ><h3 style="font-family: sans-serif;">Multi-Cloud Total Cost of Ownership (TCO) Calculator</h3></td>
                 
                <tr>
                  <td >
                    <p style="padding: 0px; margin: 0px; line-height: 25px; margin-bottom: 20px; font-size: 15px; font-family: sans-serif;"><b style="color:red;">Disclaimer:</b>  This tool is designed to help organizations assess their progress with cloud adoption and identify
          gaps in organizational skills and processes. The recommendations provided are for informational purposes only,
          and based upon the information you provide and AutoConfigs experience in assisting organizations transition to the
          cloud. Your organization is responsible for making its own independent assessment of the recommendations and
          for any use of AutoConfigs products or services.</p>
          
                  </td>
                </tr>
              </table>
              </div>
        <!-- <h3 class="text-center p-main-heading">Multi-Cloud Total Cost of Ownership (TCO) Calculator</h3> -->

        <div [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'">
            <div class="p-box">
                <label>Time frame</label>
                <p class="p-border-box">{{Timeframe > 1 ? Timeframe + ' Years' : Timeframe + ' Year'}}</p>
            </div>
        </div>
        <div *ngIf="shareDataService.selectedServers.includes('aws')" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'">
            <div class="p-box">
                <label>AWS Region</label>
                <p class="p-border-box">{{AWSRegins}}</p>
            </div>
        </div>
        <div *ngIf="shareDataService.selectedServers.includes('azure')" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'">
            <div class="p-box">
                <label>Azure Region</label>
                <p class="p-border-box">{{AzureRegins}}</p>
            </div>
        </div>
        <div *ngIf="shareDataService.selectedServers.includes('gcp')" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'">
            <div class="p-box">
                <label>GCP Region</label>
                <p class="p-border-box">{{GCPRegins}}</p>
            </div>
        </div>
        <div class="p-hr"></div>
        <div>
            <h3 class="text-center p-main-heading"> Your estimated cost saving over {{Timeframe}} year(s) with</h3>
            <h2 class="text-center p-orange-heading" *ngIf="sectionCount > 3">AWS - $ {{totalSaveCostAWS | number}} OR Azure - $ {{totalSaveCostAzure | number}} OR GCP - $ {{totalSaveCostGCP | number}}</h2>
            <h2 class="text-center p-orange-heading" *ngIf="sectionCount == 3 && shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('azure')">AWS - $ {{totalSaveCostAWS | number}} OR Azure - $ {{totalSaveCostAzure | number}}</h2>
            <h2 class="text-center p-orange-heading" *ngIf="sectionCount == 3 && shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('gcp')">AWS - $ {{totalSaveCostAWS | number}} OR GCP - $ {{totalSaveCostGCP | number}}</h2>
            <h2 class="text-center p-orange-heading" *ngIf="sectionCount == 3 && shareDataService.selectedServers.includes('gcp') && shareDataService.selectedServers.includes('azure')">GCP - $ {{totalSaveCostGCP | number}} OR Azure - $ {{totalSaveCostAzure | number}}</h2>
            <h2 class="text-center p-orange-heading" *ngIf="sectionCount == 2 && shareDataService.selectedServers.includes('aws') && !shareDataService.selectedServers.includes('azure') && !shareDataService.selectedServers.includes('gcp')">AWS - $ {{totalSaveCostAWS | number}}</h2>
           <h2 class="text-center p-orange-heading" *ngIf="sectionCount == 2 && !shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('azure') && !shareDataService.selectedServers.includes('gcp')">Azure - $ {{totalSaveCostAzure | number}}</h2>
           <h2 class="text-center p-orange-heading" *ngIf="sectionCount == 2 && !shareDataService.selectedServers.includes('aws') && !shareDataService.selectedServers.includes('azure') && shareDataService.selectedServers.includes('gcp')">GCP - $ {{totalSaveCostGCP | number}}</h2>
        </div>
        <div>
            <div class="p-col-two">
                <p class="p-black-regular">Total on-premises vs. {{this.serverString.replace('and', 'vs.')}} cost over time</p>
                <p class="p-gray-regular">Savings from running workloads in {{this.serverString}} accrue over time. The following shows how
                    those savings add up over years.</p>
            </div>
            <div class="p-col-two" style="position: relative; width: 370px; height:240px;">
                <canvas baseChart width="300" height="280" 
                [datasets]="lineChartData"
                [labels]="lineChartLabels"
                [options]="lineChartOptions"
                [colors]="lineChartColors"
                [legend]="lineChartLegend"
                [chartType]="lineChartType"
                [plugins]="lineChartPlugins">
            </canvas>
            </div>
        </div>

        <div style="clear: both;">
            <div [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'">
                <p class="p-black-regular">Total on-premises over {{this.Timeframe}} year(s)</p>
                <p class="p-gray-regular"> TCO of on-premises environments tends to be driven by compute and data center costs.</p>
                <div  style="position: relative; width: 400px; right: 60px; height:250px;">
                    <canvas baseChart 
                        [data]="pieChartData" 
                        [labels]="pieChartLabels" 
                        [chartType]="pieChartType"
                        [options]="pieChartOptions"
                        [plugins]="pieChartPlugins"
                        [legend]="pieChartLegend">
                    </canvas>
                    <div class="p-main-heading text-center"><h5>Total : $ {{totalCost | number}}</h5></div>
                </div>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('azure')" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'">
                <p class="p-black-regular">Total Azure over {{this.Timeframe}} year(s)</p>
                <p class="p-gray-regular"> In Azure, certain cost categories decrease or go away completely.</p>
                <div  style="position: relative; width: 400px; right: 60px; height:250px;" >
                    <canvas baseChart 
                        [data]="azurePieChartData" 
                        [labels]="azurePieChartLabels" 
                        [chartType]="pieChartType"
                        [options]="pieChartOptions"
                        [plugins]="pieChartPlugins"
                        [legend]="pieChartLegend">
                    </canvas>
                    <div class="p-main-heading text-center"><h5>Total : $ {{azureData.totalCost | number}}</h5></div>
                </div>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('aws')" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'">
                <p class="p-black-regular">Total Amazon cost over {{this.Timeframe}} year(s)</p>
                <p class="p-gray-regular">TCO of AWS environments tends to be driven by compute and data center costs.</p>
                <div  style="position: relative; width: 400px; right: 60px; height:250px;">
                    <canvas baseChart 
                        [data]="awsPieChartData" 
                        [labels]="awsPieChartLabels" 
                        [chartType]="pieChartType"
                        [options]="pieChartOptions"
                        [plugins]="pieChartPlugins"
                        [legend]="pieChartLegend">
                    </canvas>
                    <div class="p-main-heading text-center"><h5>Total : $ {{awsData.totalCost | number}}</h5></div>
                </div>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('gcp')" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'">
                <p class="p-black-regular">Total GCP cost over {{this.Timeframe}} year(s)</p>
                <p class="p-gray-regular">In GCP, certain cost categories decrease or go away completely.</p>
                <div  style="position: relative; width: 400px; right: 60px; height:250px;">
                    <canvas baseChart 
                        [data]="gcpPieChartData" 
                        [labels]="gcpPieChartLabels" 
                        [chartType]="pieChartType"
                        [options]="pieChartOptions"
                        [plugins]="pieChartPlugins"
                        [legend]="pieChartLegend">
                    </canvas>
                    <div class="p-main-heading text-center"><h5>Total : $ {{gcpData.totalCost | number}}</h5></div>
                </div>
            </div>
        </div>



        <div  style="clear: both;">
            <div [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'">
                    <p class="p-border-box">On-premises cost breakdown summary</p>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('azure')" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'">
                    <p class="p-border-box">Azure cost breakdown summary</p>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('aws')" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'">
                <p class="p-border-box">Amazon cost breakdown summary</p>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('gcp')" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'">
                <p class="p-border-box">GCP cost breakdown summary</p>
            </div>
        </div>


        <div style="clear: both;">
            <div *ngIf="(newResult | json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two p-border-box' : sectionCount == 3 ? 'p-col-three p-border-box' : 'p-col-four p-border-box'" style="margin-top: 10px;">
               <div >
                 <div>
                    <div style="width: 70%; float: left;"><p class="p-gray-regular">Server</p></div>
                    <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{totalServerCost | number}}</p></div>
                 </div>
                 <div>
                    <div style="width: 70%; float: left;"><p class="p-gray-regular">Storage</p></div>
                    <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{totalstorageCost | number}}</p></div>
                 </div>
                 <div>
                    <div style="width: 70%; float: left;"><p class="p-gray-regular">Network</p></div>
                    <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{totalNetworkingcost | number}}</p></div>
                 </div>
                 <!-- <div>
                    <div style="width: 70%; float: left;"><p class="p-gray-regular">IT Labor</p></div>
                    <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{totalitlaborcost | number}}</p></div>
                 </div> -->
                 <div class="p-hr"></div>
                 <div>
                    <div style="width: 70%; float: left;"><p class="p-gray-regular">Total</p></div>
                    <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{totalCost | number}}</p></div>
                 </div>
                </div> 
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('azure') && (azureData| json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two p-border-box' : sectionCount == 3 ? 'p-col-three p-border-box' : 'p-col-four p-border-box'" style="margin-top: 10px;">
                <div >
                  <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">Server</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{azureData?.totalServerCost | number}}</p></div>
                  </div>
                  <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">Storage</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{azureData?.totalstorageCost | number}}</p></div>
                  </div>
                  <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">Network</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{azureData?.totalNetworkingcost | number}}</p></div>
                  </div>
                  <!-- <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">IT Labor</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{azureData?.totalitlaborcost | number}}</p></div>
                  </div> -->
                  <div class="p-hr"></div>
                  <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">Total</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{azureData?.totalCost | number}}</p></div>
                  </div>
                 </div> 
             </div>
             <div *ngIf="shareDataService.selectedServers.includes('aws') && (awsData | json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two p-border-box' : sectionCount == 3 ? 'p-col-three p-border-box' : 'p-col-four p-border-box'" style="margin-top: 10px;">
                <div >
                  <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">Server</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{awsData?.totalServerCost | number}}</p></div>
                  </div>
                  <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">Storage</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{awsData?.totalstorageCost | number}}</p></div>
                  </div>
                  <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">Network</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{awsData?.totalNetworkingcost | number}}</p></div>
                  </div>
                  <!-- <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">IT Labor</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{awsData?.totalitlaborcost | number}}</p></div>
                  </div> -->
                  <div class="p-hr"></div>
                  <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">Total</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{awsData?.totalCost | number}}</p></div>
                  </div>
                 </div> 
             </div>
             <div *ngIf="shareDataService.selectedServers.includes('gcp') && (gcpData| json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two p-border-box' : sectionCount == 3 ? 'p-col-three p-border-box' : 'p-col-four p-border-box'" style="margin-top: 10px;">
                <div >
                  <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">Server</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{gcpData?.totalServerCost | number}}</p></div>
                  </div>
                  <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">Storage</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{gcpData?.totalstorageCost | number}}</p></div>
                  </div>
                  <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">Network</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{gcpData?.totalNetworkingcost | number}}</p></div>
                  </div>
                  <!-- <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">IT Labor</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{gcpData?.totalitlaborcost | number}}</p></div>
                  </div> -->
                  <div class="p-hr"></div>
                  <div>
                     <div style="width: 70%; float: left;"><p class="p-gray-regular">Total</p></div>
                     <div style="width: 30%; float: left;"><p class="p-gray-regular">$ {{gcpData?.totalCost | number}}</p></div>
                  </div>
                 </div> 
             </div>
        </div>
        <div class="pdfPageBreak" ></div>
        <!-- <div class="pdfPageBreak" *ngIf="((shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('azure'))||(shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('gcp')) || (shareDataService.selectedServers.includes('gcp') && shareDataService.selectedServers.includes('azure')))"></div> -->
        <div >
            <div *ngIf="(newResult | json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                <p class="p-border-box">Estimated on-premises cost ({{Timeframe}} Year(s))</p>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('azure') && (azureData| json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                <p class="p-border-box">Estimated Azure cost ({{Timeframe}} Year(s))</p>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('aws') && awsData" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                <p class="p-border-box">Estimated Amazon cost ({{Timeframe}} Year(s))</p>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('gcp') && (gcpData| json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                <p class="p-border-box">Estimated GCP cost ({{Timeframe}} Year(s))</p>
            </div>
        </div>



        <div >
            <div *ngIf="(newResult | json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">On-premises Server Costs</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">$ {{totalServerCost | number}}</p></div>
                 </div>
               
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('azure') && (azureData| json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">Azure Server Costs</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">${{azureData?.totalServerCost | number}}</p></div>
                 </div>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('aws') && (awsData | json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">AWS Server Costs</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">${{awsData?.totalServerCost | number}}</p></div>
                 </div>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('gcp') && (gcpData| json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">GCP Server Costs</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">${{gcpData?.totalServerCost | number}}</p></div>
                 </div>
            </div>
        </div>
        <div id="pdfServer">
            <div *ngIf="(newResult | json) != '{}'" class="p-border-box p-serverHardwareCosts" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="margin-top: 10px;">
                <div>
                    <h4 *ngIf="newResult.VirtualServerHardwareCosts[0]">Virtual Host Sizing for Virtualized Environments</h4>
                    <table class="table-responsive" width="100%" id="p-customers" *ngIf="newResult.VirtualServerHardwareCosts[0]">
                        <tr class="bold-text">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">App</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;"># VMs</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Host Type</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;"># Cores</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">RAM</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;"># Servers</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">VM Density</th>
                        </tr>
                        <tr *ngFor="let item of newResult.VirtualServerHardwareCosts">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[0].Value}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[1].Value}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[2].Value}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[3].Value}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[4].Value}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[5].Value | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[6].Value}} %</td>
                        </tr>
                    </table>
                    <br  *ngIf="newResult.VirtualServerHardwareCosts[0]"/>
                    <h4>Server Hardware Costs</h4>
                    <table class="table-responsive" width="100%" id="p-customers">
                        <tr class="bold-text">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;"># of Servers</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;"># of Cores</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">RAM (GB)</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Units (U)</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Power (KW)</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Unit Cost</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Unit Disc.</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Total Cost</th>
                        </tr>
                        <tr *ngFor="let item of newResult.ServerHardwareCostsTableData">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[0].Value}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[1].Value}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[2].Value}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[3].Value}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[4].Value}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{item[5].Value | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[6].Value}} %</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{item[7].Value | number}}</td>
                        </tr>
                        <tr class="bold-text">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{this.serverCost?.totalServers}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{this.serverCost?.totalUnit}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{this.serverCost?.totalPowser}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{this.serverCost?.totalCost | number}}</td>
                        </tr>
                    </table>
                </div>
                <div>
                    <table >
                        <tr *ngFor="let item of newResult.ServerHardwareCosts">
                            <td width="70%">{{item.Key}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>Rack Infrastructure Costs</h4>
                            </td>
                        </tr>
                        <tr *ngFor="let item of newResult.RackInfrastructureCosts">
                            <td width="70%">{{item.Key}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr *ngFor="let item of newResult.TotalRackInfrastructureCosts" class="total-bold-text">
                            <td width="70%">{{item.Key}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>

                        <tr style="border-bottom: 1px solid #f1f1f1" *ngIf="newResult.VirtualSoftwareCost[0]">
                            <td colspan="2">
                                <h4>Virtualization Software Costs</h4>
                            </td>
                        </tr>
                        <tr *ngFor="let item of newResult.VirtualSoftwareCost">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #f1f1f1" *ngIf="newResult.GuestOSLicense[0]">
                            <td colspan="2">
                                <h4>Guest OS License</h4>
                            </td>
                        </tr>
                        <tr *ngFor="let item of newResult.GuestOSLicense">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr *ngFor="let item of newResult.TotalVirtualLicenseAndMaintenanceCost" class="total-bold-text">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>


                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>Server Software Costs (Host OS)</h4>
                            </td>
                        </tr>
                        <tr *ngFor="let item of newResult.ServerSoftwareCost;let i = index" [ngClass]="{'bold-text': newResult.ServerSoftwareCost.length === 4 && i == 3}">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr *ngFor="let item of newResult.TotalDBSoftwareLicenseCost" class="total-bold-text">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>Facilities Costs (data center space, power and cooling)</h4>
                            </td>
                        </tr>
                        <tr *ngFor="let item of newResult.FacilitiesCosts">
                            <td  width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr *ngFor="let item of newResult.TotalFacilitiesCosts" class="total-bold-text">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                </div>
                <div *ngIf="newResult.ServerCostBreakDown.length > 0">
                    <h4>Server cost break-down</h4>
                    <table class="table-responsive" width="100%" id="p-customers">
                        <tr class="bold-text">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Category</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Cost</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">% of Total Cost</th>
                        </tr>
                        <tr>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Hardware</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{newResult.ServerCostBreakDown[0].Value | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{newResult.ServerCostBreakDown[3].Value}} %</td>
                        </tr>
                        <tr>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Software</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{newResult.ServerCostBreakDown[1].Value | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{newResult.ServerCostBreakDown[4].Value}} %</td>
                        </tr>
                        <tr>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Operating Costs (3 Yrs.)</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{newResult.ServerCostBreakDown[2].Value | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{newResult.ServerCostBreakDown[5].Value}} %</td>
                        </tr>
                        <tr class="bold-text">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Total</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{newResult.ServerCostBreakDown[6].Value | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{newResult.ServerCostBreakDown[7].Value}} %</td>
                        </tr>
                    </table>
                </div>
                <div>
                    <table >
                        <tr *ngFor="let item of newResult.TotalServerCost" class="bold-text">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                </div>
                
            </div>
            <div class="p-border-box p-serverHardwareCosts" *ngIf="shareDataService.selectedServers.includes('azure') && (azureData| json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="margin-top: 10px;">
              
                <div *ngIf="azureData?.VirtualMachinesCost.length > 0 || azureData?.SQLDatabaseCost.length > 0">
                    <!-- <table>
                        
                        <tr *ngFor="let item of azureData?.VirtualMachinesHoursPerMonth">
                            <td>{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table> -->
                    <table *ngIf="azureData?.VirtualMachinesCost.length > 0">
                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>Virtual Machines cost</h4>
                            </td>
                        </tr>
                    </table>
                    <table class="table-responsive" width="100%" id="p-customers" *ngIf="azureData?.VirtualMachinesCost.length > 0">
                        <tr class="bold-text">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Instance</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Type</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Number of machine</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hours/Month</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Monthly retail price</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Yearly retail price</th>
                        </tr>
                        <tr *ngFor="let item of azureData?.VirtualMachinesCost">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Instance}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Type}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.NumberOfVirtualMachines}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.MonthlyHours}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerMonth | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"> {{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerYear | number}}</td>
                        </tr>
                    </table>
                    <table *ngIf="azureData?.TotalVirtualMachinesCost.length > 0">
                        <tr *ngFor="let item of azureData?.TotalVirtualMachinesCost" class="bold-text">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                    <table *ngIf="azureData?.SQLDatabaseCost.length > 0">
                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>SQL Server VM Cost</h4>
                            </td>
                        </tr>
                    </table>
                    <table class="table-responsive" width="100%" id="p-customers" *ngIf="azureData?.SQLDatabaseCost.length > 0">
                        <tr class="bold-text">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Instance</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Type</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Number of machine</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hours/Month</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Monthly retail price</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Yearly retail price</th>
                        </tr>
                        <tr *ngFor="let item of azureData?.SQLDatabaseCost">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Instance}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Type}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.NumberOfVirtualMachines}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.MonthlyHours}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerMonth | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"> {{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerYear | number}}</td>
                        </tr>
                    </table>
                    <table  *ngIf="azureData?.TotalSQLDatabaseCost.length > 0">
                        <tr *ngFor="let item of azureData?.TotalSQLDatabaseCost" class="bold-text">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        
                    </table>
                    <table  *ngIf="azureData?.ServerSoftwareCosts.length > 0">
                        <tr *ngFor="let item of azureData?.ServerSoftwareCosts">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        
                    </table>
                    <table *ngIf="azureData?.TotalAzureComputeCost.length > 0">
                        <tr *ngFor="let item of azureData?.TotalAzureComputeCost" class="bold-text">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        
                    </table>
                    <table *ngIf="azureData?.VirtualMachinesCostNote.length > 0">
                        <tr *ngFor="let item of azureData?.VirtualMachinesCostNote" >
                            <td colspan="2">{{item.Label}}</td>
                        </tr>
                    </table>
                </div>
             </div>
             <div class="p-border-box p-serverHardwareCosts" *ngIf="shareDataService.selectedServers.includes('aws') && (awsData | json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="margin-top: 10px;">
                <!-- <div>
                    <h4>{{Timeframe}} Yr. Partial Upfront EC2 Instance Savings Plan</h4>
                    <table class="table-responsive" width="100%" id="p-customers">
                        <tr>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">AWS Instance</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Upfront</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hourly</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Total Costs</th>
                        </tr>
                        <tr *ngFor="let item of awsData?.UpfrontEC2InstanceSavingPlan">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.AWSInstance}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.UpfrontFee | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.HourlyCost }}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.TotalCost | number}}</td>
                        </tr>
                        <tr class="bold-text">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{awsData?.UpfrontEC2InstanceSavingPlanTotal[0].Label}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{awsData?.UpfrontEC2InstanceSavingPlanTotal[0].Unit === 'USD' ? '$' : awsData?.UpfrontEC2InstanceSavingPlanTotal[0].Unit}} {{awsData?.UpfrontEC2InstanceSavingPlanTotal[0].Value | number}}</td>
                        </tr>
                    </table>
                </div>

                <div>
                    <h4>On-Demand</h4>
                    <table class="table-responsive" width="100%" id="p-customers">
                        <tr>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">AWS Instance</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Upfront</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hourly</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Total Costs</th>
                        </tr>
                        <tr *ngFor="let item of awsData?.OnDemandUtilization">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.AWSInstance}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} -</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.PricePerHr}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.OnDemandTotalCost | number}}</td>
                        </tr>
                        <tr class="bold-text">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{awsData?.OnDemandUtilizationTotal[0].Label}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{awsData?.OnDemandUtilizationTotal[0].Unit === 'USD' ? '$' : awsData?.OnDemandUtilizationTotal[0].Unit}} {{awsData?.OnDemandUtilizationTotal[0].Value | number}}</td>
                        </tr>
                    </table>
                </div> -->

                <div>
                    <h4>Lowest Priced Instance</h4>
                    <table class="table-responsive" width="100%" id="p-customers">
                        <tr>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">AWS Instance</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hours/Month</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hourly</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Cost</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Type</th>
                        </tr>
                        <tr *ngFor="let item of awsData?.LowestPricedInstanceUtilization">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.AWSInstance}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.MonthlyHours}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.PricePerHr}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit }} {{item.Cost | number}} </td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"> {{item.Type}}</td>
                        </tr>
                        <tr class="bold-text">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Total Cost</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{awsData?.EC2Costs[0].Unit === 'USD' ? '$' : awsData?.EC2Costs[0].Unit}} {{awsData?.EC2Costs[0].Value | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                        </tr>
                    </table>
                </div>
                <div>
                    <table class="table-class">
                        <tr>
                            <th width="70%">{{awsData?.EC2Costs[0].Label}}</th>
                            <th align="right">{{awsData?.EC2Costs[0].Unit === 'USD' ? '$' : awsData?.EC2Costs[0].Unit}} {{awsData?.EC2Costs[0].Value | number}}</th>
                        </tr>
                    </table>
                </div>
                <!-- <div>
                    <h4>EC2 Instance Savings Plan discounts (if Applicable)</h4>
                </div>
                <div>
                    <table class="table-responsive" width="100%" id="p-customers">
                        <tr>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">AWS Instance</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Instance type</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;"># Instances</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Upfront fee</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hourly</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Total Cost</th>
                        </tr>
                        <tr *ngFor="let item of awsData?.EC2InstanceSavingsPlan">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.AWSInstance}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.InstanceType}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.PricePerHr}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.UpfrontFee | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.HourlyCost | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.TotalCost | number}}</td>
                        </tr>
                    </table>
                    <table >
                        <tr class="bold-text">
                            <td >{{awsData?.TotalEC2InstanceSavingsPlan[0].Label}}</td>
                            <td align="right">{{awsData?.TotalEC2InstanceSavingsPlan[0].Unit === 'USD' ? '$' : awsData?.TotalEC2InstanceSavingsPlan[0].Unit}} {{awsData?.TotalEC2InstanceSavingsPlan[0].Value | number}}</td> 
                        </tr>
                    </table>
                </div> -->
                <div>
                    <table>
                        <tr>
                            <td >{{awsData?.DiscountTierApplicable[0].Label}}</td>
                            <td align="right">{{awsData?.DiscountTierApplicable[0].Value}}%</td> 
                        </tr>
                        <tr class="bold-text">
                            <td >{{awsData?.TotalDiscountAndSupport[0].Label}}</td>
                            <td align="right">$ {{awsData?.TotalDiscountAndSupport[0].Value | number}}</td> 
                        </tr>
                    </table>
                    <table class="table-class" *ngIf="awsData?.TotalDiscountAndSupport.length > 1">
                        <tr>
                            <th width="70%">{{awsData?.TotalDiscountAndSupport[1].Label}}</th>
                            <th align="right">{{awsData?.TotalDiscountAndSupport[1].Unit === 'USD' ? '$' : awsData?.TotalDiscountAndSupport[1].Unit}} {{awsData?.TotalDiscountAndSupport[1].Value | number}}</th>
                        </tr>
                    </table>
                </div>
                <div *ngIf="awsData?.ServerSoftwareCosts.length > 0 && awsData?.ServerSoftwareCosts[0]?.Value != 0">
                    <table class="table-class">
                        <h4>Server Software Costs (BYOL Only)</h4>
                        <tr *ngFor="let item of awsData?.ServerSoftwareCosts">
                            <th>{{item.Label}}</th>
                            <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th> 
                        </tr>
                    </table>
                </div>
                <div *ngIf="awsData?.CloudWatchMetrics">
                    <table>
                        <tr *ngFor="let item of awsData?.CloudWatchMetrics">
                            <td>{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                    <table class="table-class" *ngIf="awsData?.TotalCloudWatchMetrics.length > 0">
                        <tr>
                            <th width="70%">{{awsData?.TotalCloudWatchMetrics[0].Label}}</th>
                            <th align="right">{{awsData?.TotalCloudWatchMetrics[0].Unit === 'USD' ? '$' : awsData?.TotalCloudWatchMetrics[0].Unit}} {{awsData?.TotalCloudWatchMetrics[0].Value | number}}</th>
                        </tr>
                    </table>
                </div>
             </div>
             <div class="p-border-box p-serverHardwareCosts" *ngIf="shareDataService.selectedServers.includes('gcp') && (gcpData| json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="margin-top: 10px;">
              
                <div *ngIf="gcpData?.VirtualMachinesCost.length > 0 || gcpData?.SQLDatabaseCost.length > 0">
                    <!-- <table>
                        
                        <tr *ngFor="let item of gcpData?.VirtualMachinesHoursPerMonth">
                            <td>{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table> -->
                    <table  *ngIf="gcpData?.VirtualMachinesCost.length > 0">
                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>Virtual Machines cost</h4>
                            </td>
                        </tr>
                    </table>
                    <table class="table-responsive" width="100%" id="p-customers" *ngIf="gcpData?.VirtualMachinesCost.length > 0">
                        <tr class="bold-text">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Instance</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Type</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Number of machine</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hours/Month</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Monthly retail price</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Yearly retail price</th>
                        </tr>
                        <tr *ngFor="let item of gcpData?.VirtualMachinesCost">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Instance}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Type}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.NumberOfVirtualMachines}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.MonthlyHours}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerMonth | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"> {{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerYear | number}}</td>
                        </tr>
                    </table>
                    <table *ngIf="gcpData?.WindowsOSCost.length > 0">
                        <tr *ngFor="let item of gcpData?.WindowsOSCost">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                    <table *ngIf="gcpData?.TotalVirtualMachinesCost.length > 0">
                        <tr *ngFor="let item of gcpData?.TotalVirtualMachinesCost" class="bold-text">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                    <table *ngIf="gcpData?.SQLDatabaseCost.length > 0">
                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>SQL Server VM Cost</h4>
                            </td>
                        </tr>
                    </table>
                    <table class="table-responsive" width="100%" id="p-customers" *ngIf="gcpData?.SQLDatabaseCost.length > 0">
                        <tr class="bold-text">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Instance</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Type</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Number of machine</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hours/Month</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Monthly retail price</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Yearly retail price</th>
                        </tr>
                        <tr *ngFor="let item of gcpData?.SQLDatabaseCost">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Instance}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Type}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.NumberOfVirtualMachines}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.MonthlyHours}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerMonth | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;"> {{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerYear | number}}</td>
                        </tr>
                    </table>
                    <table *ngIf="gcpData?.SQLWindowsOSCost.length > 0">
                        <tr *ngFor="let item of gcpData?.SQLWindowsOSCost">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        
                    </table>
                    <table *ngIf="gcpData?.SQLEnterpriseCost.length > 0">
                        <tr *ngFor="let item of gcpData?.SQLEnterpriseCost">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        
                    </table>
                    <table  *ngIf="gcpData?.TotalSQLDatabaseCost.length > 0">
                        <tr *ngFor="let item of gcpData?.TotalSQLDatabaseCost">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        
                    </table>
                    <table  *ngIf="gcpData?.TotalSQLDatabaseCost.length > 0">
                        <tr *ngFor="let item of gcpData?.TotalSQLDatabaseCost" class="bold-text">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        
                    </table>
                    <table *ngIf="gcpData?.VirtualMachinesCostNote.length > 0">
                        <tr *ngFor="let item of gcpData?.VirtualMachinesCostNote" >
                            <td colspan="2">{{item.Label}}</td>
                        </tr>
                    </table>
                </div>
             </div>
             
        </div>

        <div class="pdfPageBreak" ></div>
        <div class="pdfPageBreak" *ngIf="pdfSecondPageBreak?.server"></div>
        <div >
            <div *ngIf="(newResult | json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">On-premises Storage Cost</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">$ {{totalstorageCost | number}}</p></div>
                 </div>
               
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('azure') && (azureData| json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">Azure Storage Costs</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">${{azureData?.totalstorageCost | number}}</p></div>
                 </div>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('aws') && (awsData | json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">AWS Storage Costs</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">${{awsData?.totalstorageCost | number}}</p></div>
                 </div>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('gcp') && (gcpData| json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">GCP Storage Costs</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">${{gcpData?.totalstorageCost | number}}</p></div>
                 </div>
            </div>
        </div>
        <div id="pdfStorage">
            <div *ngIf="(newResult | json) != '{}'" class="p-border-box p-serverHardwareCosts" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="margin-top: 10px;">
                <div>
                    <table>
                        <h4 *ngIf="newResult.StorageSANCost.length > 0">SAN Cost</h4>
                        <tr *ngFor="let item of newResult.StorageSANCost">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr *ngFor="let item of newResult.TotalStorageSANCost" class="total-bold-text">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>

                        <h4 *ngIf="newResult.StorageBackupCost.length > 0">Storage backup cost</h4>
                        <tr *ngFor="let item of newResult.StorageBackupCost">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right" *ngIf="item.Label === 'Type of Tape Library used'">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value}}</td>
                            <td align="right" *ngIf="item.Label !== 'Type of Tape Library used'">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr *ngFor="let item of newResult.TotalStorageBackupCost" class="total-bold-text">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>

                        <h4 *ngIf="newResult.StorageOverheadCost.length > 0">Storage Overhead cost (data center space, power, cooling, storage administrator)</h4>
                        <tr *ngFor="let item of newResult.StorageOverheadCost">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr *ngFor="let item of newResult.TotalStorageOverheadCost" class="total-bold-text">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>

                        <tr *ngFor="let item of newResult.TotalDatacenterSpacePowerCoolingCost" class="total-bold-text">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>





                        <!-- <tr *ngFor="let item of newResult.StorageCostBreakDown">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Cost | number}}</td>
                        </tr> -->
                    </table>
                </div>
                <div *ngIf="newResult.ServerCostBreakDown.length > 0">
                    <h4>Storage cost break-down</h4>
                    <table class="table-responsive" width="100%" id="customers">
                        <tr class="bold-text">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Category</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Cost</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">% of Total Cost</th>
                        </tr>
                        <tr *ngFor="let item of newResult.StorageCostBreakDown">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{item.Cost}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.PercentageOfTotalCost}}</td>
                        </tr>
                    </table>
                </div>
                <div>
                    <table>
                        <tr *ngFor="let item of newResult.TotalStorageCost" class="total-bold-text">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                </div>
                
            </div>
            <div class="p-border-box p-serverHardwareCosts" *ngIf="(azureData | json) != '{}' && shareDataService.selectedServers.includes('azure')" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="margin-top: 10px;">
                <div *ngIf="azureData?.PageBlobStorageCost.length > 0">
                    <table >
                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>Page Blob storage</h4>
                            </td>
                        </tr>
                        <tr *ngFor="let item of azureData?.PageBlobStorageCost">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                        </tr>
                        <tr *ngFor="let item of azureData?.TotalPageBlobStorageCost" class="bold-text">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                        </tr>
                    </table>
                </div>
                <div *ngIf="azureData?.PremiumStorageCost.length > 0">
                    <table>
                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>Premium storage</h4>
                            </td>
                        </tr>
                        <tr *ngFor="let item of azureData?.PremiumStorageCost">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                        </tr>
                        <tr *ngFor="let item of azureData?.TotalPremiumStorageCost" class="bold-text">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                        </tr>
                    </table>
                </div>
                    <div *ngIf="azureData?.FileStorageCost.length > 0">
                        <table >
                            <tr style="border-bottom: 1px solid #f1f1f1">
                                <td colspan="2">
                                    <h4>File storage</h4>
                                </td>
                            </tr>
                            <tr *ngFor="let item of azureData?.FileStorageCost">
                                <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                            </tr>
                            <tr *ngFor="let item of azureData?.TotalFileStorageCost" class="bold-text">
                                <td >{{item.Label}}</td>
                                <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                            </tr>
                        </table>
                    </div>
                    <div *ngIf="azureData?.BlockBlobStorageHotTier.length > 0">
                        <table>
                            <tr style="border-bottom: 1px solid #f1f1f1">
                                <td colspan="2">
                                    <h4>Block Blob storage Hot tier</h4>
                                </td>
                            </tr>
                            <tr *ngFor="let item of azureData?.BlockBlobStorageHotTier">
                                <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                            </tr>
                            <tr *ngFor="let item of azureData?.TotalBlockBlobStorageHotTier" class="bold-text">
                                <td >{{item.Label}}</td>
                                <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                            </tr>
                        </table>
                    </div>
                    <div *ngIf="azureData?.BlockBlobStorageCoolTier.length > 0">
                        <table >
                            <tr style="border-bottom: 1px solid #f1f1f1">
                                <td colspan="2">
                                    <h4>Block Blob storage Cool tier</h4>
                                </td>
                            </tr>
                            <tr *ngFor="let item of azureData?.BlockBlobStorageCoolTier">
                                <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                            </tr>
                            <tr *ngFor="let item of azureData?.TotalBlockBlobStorageCoolTier" class="bold-text">
                                <td >{{item.Label}}</td>
                                <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                            </tr>
                        </table>
                    </div>
                    <!-- <div *ngIf="azureData?.SQLDatabaseCost.length > 0">
                        <table class="table-responsive">
                            <tr style="border-bottom: 1px solid #f1f1f1">
                                <td colspan="2">
                                    <h4>SQL Server VM storage cost</h4>
                                </td>
                            </tr>
                            <tr *ngFor="let item of azureData?.SQLDatabaseCost">
                                <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                            </tr>
                            <tr *ngFor="let item of azureData?.TotalSQLDatabaseCost" class="bold-text">
                                <td >{{item.Label}}</td>
                                <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                            </tr>
                        </table>
                    </div> -->
                    <div *ngIf="azureData?.SQLServerVMStorageCost.length > 0">
                    <table>
                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>SQL Server VM storage cost</h4>
                            </td>
                        </tr>
                    </table>
                    <table class="table-responsive" width="100%" id="customers" *ngIf="azureData?.SQLServerVMStorageCost.length > 0">
                        <tr class="bold-text">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Azure disk</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Usable Storage Volume(GB)</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Disk price per month</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Number of disks</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Total IOPS</th>
                        </tr>
                        <tr *ngFor="let item of azureData?.SQLServerVMStorageCost">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.AzureDiskMatch}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.UsableStorageVolumeGB}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.DiskPricePerMonth | number}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.NumberOfDisks}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.TotalIOPS}}</td>
                        </tr>
                    </table>
                    <table  *ngIf="azureData?.TotalSQLServerVMStorageCost.length > 0">
                        <tr *ngFor="let item of azureData?.TotalSQLServerVMStorageCost" class="bold-text">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        
                    </table>
                </div>
                
                <div *ngIf="azureData?.TotalStorageCost.length > 0">
                    <table>
                        <tr *ngFor="let item of azureData?.TotalStorageCost" class="bold-text">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                        </tr>
                    </table>
                </div>
             </div>
             <div class="p-border-box p-serverHardwareCosts" *ngIf="shareDataService.selectedServers.includes('aws') && (awsData | json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="margin-top: 10px;">
                <div *ngIf="awsData?.EBSCostEquivalentToSAN && awsData?.EBSCostEquivalentToSAN.length > 0">
                    <h4>EBS Storage - Only Standard EBS used with no IOPS requirements</h4>
                    <table >
                        <h4>EBS Costs - Equivalent to On-Premises SAN environment</h4>
                        <tr *ngFor="let item of awsData?.EBSCostEquivalentToSAN">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.value | number) : item.value}}</td>
                        </tr>
                        <tr *ngFor="let item of awsData?.TotalEBSCostEquivalentToSAN" class="bold-text">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                </div>

                <div *ngIf="awsData?.EFSCostEquivalentToNAS && awsData?.EFSCostEquivalentToNAS.length > 0">
                    <table>
                        <h4>EFS Costs -Equivalent to on-premises NAS Storage</h4>
                        <tr *ngFor="let item of awsData?.EFSCostEquivalentToNAS">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                        </tr>
                        <tr *ngFor="let item of awsData?.TotalEFSCostEquivalentToNAS" class="bold-text">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>

                        
                    </table>
                </div>
                <div *ngIf="awsData?.S3StandardInfrequentCostsStorageGB && awsData?.S3StandardInfrequentCostsStorageGB.length > 0">
                    <h4>S3 Standard – Infrequent Access Costs -Equivalent to on-premises Object Storage</h4>
                    <table>
                        <tr *ngFor="let item of awsData?.S3StandardInfrequentCostsStorageGB">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Value}}</td>
                        </tr>
                    </table>
                        <table class="table-responsive" width="100%" id="customers">
                            <tr>
                                <th colspan="2" align="center">
                                    S3 Standard – Infrequent Access storage cost
                                </th>
                            </tr>
                            <tr>
                                <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Tier</th>
                                <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Cost</th>
                            </tr>
                            <tr *ngFor="let item of awsData?.S3StandardInfrequentCosts">
                                <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Tier}}</td>
                                <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Cost}}</td>
                            </tr>
                        </table>
                        <table>
                            <tr *ngFor="let item of awsData?.AWSBusinessSupportS3StandardInfrequent">
                                <td width="70%">{{item.Label}}</td>
                                <td align="right">{{item.Value}}</td>
                            </tr>
                        </table>
                </div>

                <div *ngIf="awsData?.TotalAWSStorageCostIncludingSupport && awsData?.TotalAWSStorageCostIncludingSupport.length>0">
                    <table >
                        <tr *ngFor="let item of awsData?.TotalAWSStorageCostIncludingSupport" class="total-bold-text">
                            <td width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                </div>
                
             </div>
             <div class="p-border-box p-serverHardwareCosts" *ngIf="(gcpData | json) != '{}' && shareDataService.selectedServers.includes('gcp')" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="margin-top: 10px;">
                <div *ngIf="gcpData?.HDDPersistentDiskCost.length > 0 || gcpData?.SSDPersistentDiskCost.length > 0">
                    <table>
                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>Persistent Disk Storage</h4>
                            </td>
                        </tr>
                        <tr *ngFor="let item of gcpData?.HDDPersistentDiskCost">
                            <td >{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                        </tr>
                        <tr *ngFor="let item of gcpData?.SSDPersistentDiskCost">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                        </tr>
                    </table>
                </div>
                <div *ngIf="gcpData?.FileStoreCost.length > 0">
                    <table class="table-responsive">
                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>File Store Storage</h4>
                            </td>
                        </tr>
                        <tr *ngFor="let item of gcpData?.FileStoreCost">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                        </tr>
                    </table>
                </div>
                <div *ngIf="gcpData?.GCSCost.length > 0">
                    <table >
                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>Google Cloud Storage</h4>
                            </td>
                        </tr>
                        <tr *ngFor="let item of gcpData?.GCSCost">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                        </tr>
                    </table>
                </div>
                <div *ngIf="gcpData?.TotalGCPStorageCost.length > 0">
                    <table >
                        <tr *ngFor="let item of gcpData?.TotalGCPStorageCost" class="bold-text">
                            <td >{{item.Label}}</td>
                            <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                        </tr>
                    </table>
                </div>
             </div>
        </div>
        <div class="pdfPageBreak" ></div>
        <div class="pdfPageBreak" *ngIf="pdfSecondPageBreak?.storage"></div>
        <div >
            <div *ngIf="(newResult | json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">On-premises Network Cost</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">$ {{totalNetworkingcost | number}}</p></div>
                 </div>
               
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('azure') && (azureData| json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">Azure Network Costs</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">${{azureData?.totalNetworkingcost | number}}</p></div>
                 </div>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('aws') && (awsData | json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">AWS Network Costs</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">${{awsData?.totalNetworkingcost | number}}</p></div>
                 </div>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('gcp') && (gcpData| json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="padding-top: 15px;">
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">GCP Network Costs</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">${{gcpData?.totalNetworkingcost | number}}</p></div>
                 </div>
            </div>
        </div>
        <div id="pdfNetwork">
            <div *ngIf="(newResult | json) != '{}'" class="p-border-box p-serverHardwareCosts" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="margin-top: 10px;">
                <div>
                    <table >
                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>Networking Hardware and Software Costs</h4>
                            </td>
                        </tr>
                        <tr *ngFor="let item of newResult.NetworkHardwareAndSoftwareCost">
                            <td  width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr *ngFor="let item of newResult.TotalNetworkHardwareAndSoftwareCost" class="total-bold-text">
                            <td  width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>

                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>Bandwidth Costs (On-Premises)</h4>
                            </td>
                        </tr>
                        <tr *ngFor="let item of newResult.OnPremisesBandwidthCost">
                            <td  width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr *ngFor="let item of newResult.TotalOnPremisesBandwidthCost" class="total-bold-text">
                            <td  width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>

                        <tr style="border-bottom: 1px solid #f1f1f1">
                            <td colspan="2">
                                <h4>Network Admin Costs</h4>
                            </td>
                        </tr>
                        <tr *ngFor="let item of newResult.NetworkAdminCost">
                            <td  width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr *ngFor="let item of newResult.TotalNetworkCost" class="total-bold-text">
                            <td  width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="p-border-box p-serverHardwareCosts" *ngIf="shareDataService.selectedServers.includes('azure') && (azureData| json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="margin-top: 10px;">
                <div>
                    <table>
                        <tr *ngFor="let item of azureData?.NetworkingOutgoingBandwidth">
                            <td >{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr *ngFor="let item of azureData?.TotalNetworkCost" class="total-bold-text">
                            <td>{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="p-border-box p-serverHardwareCosts" *ngIf="shareDataService.selectedServers.includes('aws') && (awsData | json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="margin-top: 10px;">
                <div>
                    <h4>Data Transfer Costs</h4>
                    <table  *ngIf="awsData?.MonthlyDataTransferOut && awsData?.MonthlyDataTransferOut.length > 0">
                        <tr>
                            <td>{{awsData?.MonthlyDataTransferOut[0].Label}}</td>
                            <td align="right">{{awsData?.MonthlyDataTransferOut[0].Value}}</td>
                        </tr>
                     </table>
                    
                    <table class="table-responsive" width="100%" id="customers">
                        <tr>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;"></th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">US West (Oregon)</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Tier(GB)</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Monthly Cost</th>
                        </tr>
                        <tr *ngFor="let item of awsData?.DataTransferCost">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.DataTransfer}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Rate}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Tier}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.MonthlyCost}}</td>
                        </tr>
                    </table>
                    <table class="table-responsive" class="table-class">
                        <tr *ngFor="let item of awsData?.TotalDataTransferCost">
                            <th >{{item.Label}}</th>
                            <th>{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="p-border-box p-serverHardwareCosts" *ngIf="shareDataService.selectedServers.includes('gcp') && (gcpData| json) != '{}'" [class]="sectionCount == 2 ? 'p-col-two' : sectionCount == 3 ? 'p-col-three' : 'p-col-four'" style="margin-top: 10px;">
                <div>
                    <table>
                        <tr class="bold-text">
                            <td>Total GCP Network Cost</td>
                            <td align="right">$ {{gcpData?.totalNetworkingcost | number}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <!-- <div class="pdfPageBreak" ></div>
        <div class="pdfPageBreak" *ngIf="pdfSecondPageBreak?.network"></div>


        <div >
            <div *ngIf="(newResult | json) != '{}'" [class]="((shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('azure'))||(shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('gcp')) || (shareDataService.selectedServers.includes('gcp') && shareDataService.selectedServers.includes('azure'))) ? 'p-col-three' : 'p-col-two'" style="padding-top: 15px;">
                
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">on-premises IT Labour cost</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">$ {{totalitlaborcost | number}}</p></div>
                 </div>
               
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('azure') && (azureData| json) != '{}'" [class]="((shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('azure'))||(shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('gcp')) || (shareDataService.selectedServers.includes('gcp') && shareDataService.selectedServers.includes('azure'))) ? 'p-col-three' : 'p-col-two'" style="padding-top: 15px;">
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">Azure IT Labour Costs</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">${{azureData?.totalitlaborcost | number}}</p></div>
                 </div>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('aws') && (awsData | json) != '{}'" [class]="((shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('azure'))||(shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('gcp')) || (shareDataService.selectedServers.includes('gcp') && shareDataService.selectedServers.includes('azure'))) ? 'p-col-three' : 'p-col-two'" style="padding-top: 15px;">
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">AWS IT Labour Costs</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">${{awsData?.totalitlaborcost | number}}</p></div>
                 </div>
            </div>
            <div *ngIf="shareDataService.selectedServers.includes('gcp') && (gcpData| json) != '{}'" [class]="((shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('azure'))||(shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('gcp')) || (shareDataService.selectedServers.includes('gcp') && shareDataService.selectedServers.includes('azure'))) ? 'p-col-three' : 'p-col-two'" style="padding-top: 15px;">
                <div class="p-border-box" style="height: 33px;">
                    <div style="width: 70%; float: left;"><p class="p-black-regular">GCP IT Labour Costs</p></div>
                    <div style="width: 30%; float: left;"><p class="p-black-regular">${{gcpData?.totalitlaborcost | number}}</p></div>
                 </div>
            </div>
        </div>
        <div >
            <div *ngIf="(newResult | json) != '{}'" class="p-border-box p-serverHardwareCosts" [class]="((shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('azure'))||(shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('gcp')) || (shareDataService.selectedServers.includes('gcp') && shareDataService.selectedServers.includes('azure'))) ? 'p-col-three' : 'p-col-two'" style="margin-top: 10px;">
                <div>
                    <table class="table-responsive">
                        <tr *ngFor="let item of newResult.ITLaborNonDatabaseAdminCost">
                            <td  width="70%">{{item.Label}}</td>
                            <td align="right"> {{item.Unit === 'USD' ? '$' : item.Unit}}{{item.Value | number}}</td>
                        </tr>
                        <tr *ngFor="let item of newResult.ITLaborDatabaseAdminCost">
                            <td  width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>

                        <tr *ngFor="let item of newResult.TotalITLaborNonDatabaseAdminCost" class="bold-text">
                            <td  width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr *ngFor="let item of newResult.ITLaborTotalCost" class="total-bold-text">
                            <td  width="70%">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="p-border-box p-serverHardwareCosts" *ngIf="shareDataService.selectedServers.includes('azure') && (azureData| json) != '{}'" [class]="((shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('azure'))||(shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('gcp')) || (shareDataService.selectedServers.includes('gcp') && shareDataService.selectedServers.includes('azure'))) ? 'p-col-three' : 'p-col-two'" style="margin-top: 10px;">
                <div>
                    <table class="table-responsive">
                        <tr *ngFor="let item of azureData?.ITLaborCost">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                        <tr *ngFor="let item of azureData?.TotalITLaborCost" class="total-bold-text">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="p-border-box p-serverHardwareCosts" *ngIf="shareDataService.selectedServers.includes('aws') && (awsData | json) != '{}'" [class]="((shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('azure'))||(shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('gcp')) || (shareDataService.selectedServers.includes('gcp') && shareDataService.selectedServers.includes('azure'))) ? 'p-col-three' : 'p-col-two'" style="margin-top: 10px;">
                <div>
                    <table class="table-responsive">
                        <h4>EC2 Admin Costs</h4>
                        <tr *ngFor="let item of awsData?.ITLaborEC2AdminCost">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                    <table class="table-responsive" class="table-class">
                        <tr *ngFor="let item of awsData?.TotalITLaborEC2AdminCost">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                            <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                        </tr>
                    </table>
                </div>
                <div>
                    <table class="table-responsive">
                        <tr *ngFor="let item of awsData?.ITLaborRDSAdminCost">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                    <table class="table-responsive" class="table-class">
                        <tr *ngFor="let item of awsData?.TotalITLaborRDSAdminCost">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                            <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                        </tr>
                    </table>
                    <table class="table-responsive" class="table-class">
                        <tr *ngFor="let item of awsData?.TotalITAdminCostBasedOnVMsServers">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                            <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                        </tr>
                    </table>
                </div>
                <div>
                    <h4>AWS - Support Costs</h4>
                    <table class="table-responsive">
                        <tr *ngFor="let item of awsData?.AWSSupportCost">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                            <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                    <table class="table-responsive" class="table-class">
                        <tr *ngFor="let item of awsData?.TotalMonthlyAwsSpend">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                            <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                        </tr>
                    </table>
                </div>
                <div>
                    <h4>Support Costs - All Services</h4>
                    <table class="table-responsive" width="100%" id="customers">
                        <tr>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Business Level Support</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Cost</th>
                        </tr>
                        <tr *ngFor="let item of awsData?.SupportCostAllServices">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                </div>
                <div>
                    <table class="table-responsive" class="table-class">
                        <tr *ngFor="let item of awsData?.TotalSupportCostAllServices">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                            <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                        </tr>
                    </table>
                    <table class="table-responsive" class="table-class">
                        <tr *ngFor="let item of awsData?.EC2ReservedInstancesUpfrontCostAfterDisc">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                            <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                        </tr>
                    </table>    
                </div>
                <div>
                    <h4>Support Costs - Reserved Instances</h4>
                    <table class="table-responsive" width="100%" id="customers">
                        <tr>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Business Level Support</th>
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Cost</th>
                        </tr>
                        <tr *ngFor="let item of awsData?.SupportCostReservedInstances">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                        </tr>
                    </table>
                </div>
                <div>
                    <table class="table-responsive" class="table-class">
                        <tr *ngFor="let item of awsData?.TotalSupportCostReservedInstances">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                            <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                        </tr>
                    </table>
                    <table class="table-responsive" class="table-class">
                        <tr *ngFor="let item of awsData?.TotalAwsSupportCostBusiness">
                            <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                            <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                        </tr>
                    </table>
                </div>
             </div>
             <div class="p-border-box p-serverHardwareCosts" *ngIf="shareDataService.selectedServers.includes('gcp') && (gcpData| json) != '{}'" [class]="((shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('azure'))||(shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('gcp')) || (shareDataService.selectedServers.includes('gcp') && shareDataService.selectedServers.includes('azure'))) ? 'p-col-three' : 'p-col-two'" style="margin-top: 10px;">
                <div>
                    <table class="table-responsive">
                        <tr class="bold-text">
                            <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Total GCP IT Labour Cost</td>
                            <td align="right">$ {{gcpData?.totalNetworkingcost | number}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div> -->

    </div>
</div>



<section [class]="sectionCount > 3 ? 'container-fluid' : 'container'" style="clear: both;">

    <div class="row mt-0">
        <div class="col-12">
            <header>
                <h2>View report</h2>
            </header>
            <div class="mt-3 p-4 droptitle">
                <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                        <label for='Time frame'>Time frame</label>
                        <select id='Time frame' [(ngModel)]="Timeframe" (change)="onTimeFrameChange($event)">
                            <option value="1">1 Year</option>
                            <option value="2">2 Yeas</option>
                            <option value="3">3 Years</option>
                            <option value="4">4 Years</option>
                            <option value="5">5 Years</option>
                        </select>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-12 col-12" *ngIf="shareDataService.selectedServers.includes('aws')">
                        <label for='Region'> AWS Region</label>
                        <select id='Region' [(ngModel)]="AWSRegins" (change)="onAWSRegionChange($event)">
                            <option value="North Central US" [attr.value]="item.Value" *ngFor="let item of AllAWSRegins">{{item.Value}}</option>
                        </select>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-12 col-12" *ngIf="shareDataService.selectedServers.includes('azure')">
                        <label for='Region'>Azure Region</label>
                        <select id='Region' [(ngModel)]="AzureRegins" (change)="onAzureRegionChange($event)">
                            <option value="North Central US" [attr.value]="item.Value" *ngFor="let item of AllAzureRegins">{{item.Name}}</option>
                        </select>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-12 col-12" *ngIf="shareDataService.selectedServers.includes('gcp')">
                        <label for='Region'>GCP Region</label>
                        <select id='Region' [(ngModel)]="GCPRegins" (change)="onGCPRegionChange($event)">
                            <option  [attr.value]="item.Value" *ngFor="let item of AllGCPRegins">{{item.Name+"("+item.Value+")"}}</option>
                        </select>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-12 col-12" *ngIf="false">
                        <label for='Licensing program'>Licensing program</label>
                        <select id='Licensing program'>
                            <option value="Microsoft Online Services Program"> Online Services Program</option>
                        </select>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-12 col-12" *ngIf="false"style="text-align: center;">
                        <br>&nbsp;
                        <label class="switch">
                            <input type="checkbox">
                            <span class="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section id="title-one" >
        <div class="container">
            <h4 class="d-flex justify-content-center mt-3"> Your estimated cost saving over {{Timeframe}} year(s) with</h4>
            <h2 class="d-flex justify-content-center" style="color: #E9A761;" *ngIf="sectionCount > 3">AWS - $ {{totalSaveCostAWS | number}} OR Azure - $ {{totalSaveCostAzure | number}} OR GCP - $ {{totalSaveCostGCP | number}}</h2>
            <h2 class="d-flex justify-content-center" style="color: #E9A761;" *ngIf="sectionCount == 3 && shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('azure')">AWS - $ {{totalSaveCostAWS | number}} OR Azure - $ {{totalSaveCostAzure | number}}</h2>
            <h2 class="d-flex justify-content-center" style="color: #E9A761;" *ngIf="sectionCount == 3 && shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('gcp')">AWS - $ {{totalSaveCostAWS | number}} OR GCP - $ {{totalSaveCostGCP | number}}</h2>
            <h2 class="d-flex justify-content-center" style="color: #E9A761;" *ngIf="sectionCount == 3 && shareDataService.selectedServers.includes('gcp') && shareDataService.selectedServers.includes('azure')">GCP - $ {{totalSaveCostGCP | number}} OR Azure - $ {{totalSaveCostAzure | number}}</h2>
            <h2 class="d-flex justify-content-center" style="color: #E9A761;" *ngIf="sectionCount == 2 && shareDataService.selectedServers.includes('aws') && !shareDataService.selectedServers.includes('azure') && !shareDataService.selectedServers.includes('gcp')">AWS - $ {{totalSaveCostAWS | number}}</h2>
            <h2 class="d-flex justify-content-center" style="color: #E9A761;" *ngIf="sectionCount == 2 && !shareDataService.selectedServers.includes('aws') && shareDataService.selectedServers.includes('azure') && !shareDataService.selectedServers.includes('gcp')">Azure - $ {{totalSaveCostAzure | number}}</h2>
            <h2 class="d-flex justify-content-center" style="color: #E9A761;" *ngIf="sectionCount == 2 && !shareDataService.selectedServers.includes('aws') && !shareDataService.selectedServers.includes('azure') && shareDataService.selectedServers.includes('gcp')">GCP - $ {{totalSaveCostGCP | number}}</h2>
        </div>
    </section>

    <div class="row mt-3" >
        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
            <header>
                <h5>Total on-premises vs. {{this.serverString.replace('and', 'vs.')}} cost over time</h5>
                <p class="mt-2">Savings from running workloads in {{this.serverString}} accrue over time. The following shows how
                    those savings add up over years.</p>
            </header>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 col-12 p-4 droptitle" >
            <!-- <canvas id="lineChart"  style="height: 370px; width: 100%;"></canvas> -->
            <!-- <canvas baseChart 
                [datasets]="barChartData"
                [labels]="barChartLabels"
                [options]="barChartOptions"
                [plugins]="barChartPlugins"
                [legend]="barChartLegend"
                [chartType]="barChartType">
            </canvas> -->
            <canvas baseChart width="400" height="400"
                [datasets]="lineChartData"
                [labels]="lineChartLabels"
                [options]="lineChartOptions"
                [colors]="lineChartColors"
                [legend]="lineChartLegend"
                [chartType]="lineChartType"
                [plugins]="lineChartPlugins">
            </canvas>
        </div>
    </div>

    <div class="row mt-3 pl-3">
        <div class="" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12 pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12 pl-3'">
            <header>
                <h5>Total on-premises over {{this.Timeframe}} year(s)</h5>
                <p class="mt-2 c-graph-height">TCO of on-premises environments tends to be driven by compute and data center costs.
                </p>
            </header>

            <div >
                <div class="p-2 droptitle">
                    <canvas baseChart 
                        [data]="pieChartData" 
                        [labels]="pieChartLabels" 
                        [chartType]="pieChartType"
                        [options]="pieChartOptions"
                        [plugins]="pieChartPlugins"
                        [legend]="pieChartLegend">
                    </canvas>
                    <br/>
                    <div class="total-on-chart"><h4>Total : $ {{totalCost | number}}</h4></div>
                </div>
    
            </div>
        </div>
        <div class="" *ngIf="shareDataService.selectedServers.includes('azure')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12 pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12 pl-3'">
            <header>
                <h5>Total Azure cost over {{this.Timeframe}} year(s)</h5>
                <p class="mt-2 c-graph-height">In Azure, certain cost categories decrease or go away completely.</p>
            </header>

            <div >
                <div class="p-2 droptitle">
                    <canvas baseChart 
                        [data]="azurePieChartData" 
                        [labels]="azurePieChartLabels" 
                        [chartType]="pieChartType"
                        [options]="pieChartOptions"
                        [plugins]="pieChartPlugins"
                        [legend]="pieChartLegend">
                    </canvas>
                    <br/>
                    <div class="total-on-chart"><h4>Total : $ {{azureData.totalCost | number}}</h4></div>
                </div>
            </div>
        </div>
        <div class="" *ngIf="shareDataService.selectedServers.includes('aws')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <header>
                <h5>Total AWS cost over {{this.Timeframe}} year(s)</h5>
                <p class="mt-2 c-graph-height">TCO of AWS environments tends to be driven by compute and data center costs.
                </p>
            </header>
            <div >
                <div class="p-2 droptitle">
                    <canvas baseChart 
                        [data]="awsPieChartData" 
                        [labels]="awsPieChartLabels" 
                        [chartType]="pieChartType"
                        [options]="pieChartOptions"
                        [plugins]="pieChartPlugins"
                        [legend]="pieChartLegend">
                    </canvas>
                    <br/>
                    <div class="total-on-chart"><h4>Total : $ {{awsData.totalCost | number}}</h4></div>
                </div>
    
            </div>
        </div>
        <div class="" *ngIf="shareDataService.selectedServers.includes('gcp')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <header>
                <h5>Total GCP cost over {{this.Timeframe}} year(s)</h5>
                <p class="mt-2 c-graph-height">Total GCP cost over {{this.Timeframe}} year(s)
                </p>
            </header>
            <div >
                <div class="p-2 droptitle">
                    <canvas baseChart 
                        [data]="gcpPieChartData" 
                        [labels]="gcpPieChartLabels" 
                        [chartType]="pieChartType"
                        [options]="pieChartOptions"
                        [plugins]="pieChartPlugins"
                        [legend]="pieChartLegend">
                    </canvas>
                    <br/>
                    <div class="total-on-chart"><h4>Total : $ {{gcpData.totalCost | number}}</h4></div>
                </div>
    
            </div>
        </div>
    </div>

    

    <div class="row mt-3" *ngIf='false'>
        <div [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <header>
                <h5>Total on-premises cost breakdown</h5>
                <p class="mt-2">In Azure, several of the cost categories from the on-premises environment are
                    consolidated and decrease with the efficiency that comes with the cloud.</p>
            </header>
            <div class="p-2 droptitle">
                <canvas id="barChart1" width="140" height="110"></canvas>
            </div>
            <div class="mt-4">
                
                    <header>
                        <h3 style="color: #E9A761;">$99,730</h3>
                        <p class="mt-2">Cost over 5 year(s)</p>
                    </header>
                
            </div>
        </div>
        <div *ngIf="shareDataService.selectedServers.includes('azure')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <header>
                <h5>Total azure cost breakdown</h5>
                <p class="mt-2">In Azure, several of the cost categories from the on-premises environment are
                    consolidated and decrease with the efficiency that comes with the cloud.</p>
            </header>
            <div class="p-2 droptitle">
                <canvas id="barChart2" width="140" height="110"></canvas>
            </div>
            <div class="mt-4">
                
                    <header>
                        <h3 style="color: #E9A761;">$14,402</h3>
                        <p class="mt-2">Cost over 5 year(s)</p>
                    </header>
                
            </div>
        </div>
        <div *ngIf="shareDataService.selectedServers.includes('aws')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <header>
                <h5>Total amazon cost breakdown</h5>
                <p class="mt-2">In Azure, several of the cost categories from the on-premises environment are
                    consolidated and decrease with the efficiency that comes with the cloud.</p>
            </header>
            <div class="p-2 droptitle">
                <canvas id="barChart3" width="140" height="110"></canvas>
            </div>
            <div class="mt-4">
                
                    <header>
                        <h3 style="color: #E9A761;">$99,730</h3>
                        <p class="mt-2">Cost over 5 year(s)</p>
                    </header>
                
            </div>
        </div>
    </div>

    <div class="row pl-3">
        <div   [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12 pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12 pl-3'">
            <div class="droptitle mb-3 mt-3">
                <h4 class="mt-1">On-premises cost breakdown summary</h4>
            </div>
            <div class='droptitle'>
                <div class='col'>
                    <div class="row">
                        <div class="col-6">
                            <p>Server</p>
                            <p>Storage</p>
                            <p>Network</p>
                            <!-- <p>IT Labor</p> -->
                        </div>
                        <div class="col-6" style="text-align: right;">
                            <p>$ {{totalServerCost | number}}</p>
                            <p>$ {{totalstorageCost | number}}</p>
                            <p>$ {{totalNetworkingcost | number}}</p>
                            <!-- <p>$ {{totalitlaborcost | number}}</p> -->
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-6">
                            <p>Total</p>
                        </div>
                        <div class='col-6 input-field _input-field col-2'  style="text-align: right;">
                            <p>
                                $ {{totalCost | number}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="" *ngIf="shareDataService.selectedServers.includes('azure')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class="droptitle mb-3 mt-3">
                <h4 class="mt-1">Azure cost breakdown summary</h4>
            </div>
            <div class='droptitle'>
                <div class='col'>
                    <div class="row">
                        <div class="col-8">
                            <p>Server</p>
                            <p>Storage</p>
                            <p>Network</p>
                            <!-- <p>IT Labor</p> -->
                        </div>
                        <div class="col-4" style="text-align: right;">
                            <p>${{azureData?.totalServerCost | number}}</p>
                            <p>${{azureData?.totalstorageCost | number}}</p>
                            <p>${{azureData?.totalNetworkingcost | number}}</p>
                            <!-- <p>${{azureData?.totalitlaborcost | number}}</p> -->
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-8">
                            <p>Total</p>
                        </div>
                        <div class='col-4 input-field _input-field col-2' style="text-align: right;">
                            <p>${{azureData?.totalCost | number}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="" *ngIf="shareDataService.selectedServers.includes('aws')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class="droptitle mb-3 mt-3">
                <h4 class="mt-1">Amazon cost breakdown summary</h4>
            </div>
            <div class='droptitle'>
                <div class='col'>
                    <div class="row">
                        <div class="col-8">
                            <p>Server</p>
                            <p>Storage</p>
                            <p>Network</p>
                            <!-- <p>IT Labor</p> -->
                        </div>
                        <div class="col-4" style="text-align: right;">
                            <p>${{awsData?.totalServerCost | number}}</p>
                            <p>${{awsData?.totalstorageCost | number}}</p>
                            <p>${{awsData?.totalNetworkingcost | number}}</p>
                            <!-- <p>${{awsData?.totalitlaborcost | number}}</p> -->
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-8">
                            <p>Total</p>
                        </div>
                        <div class='col-4 input-field _input-field col-2' style="text-align: right;">
                            <p>${{awsData?.totalCost | number}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class=" " *ngIf="shareDataService.selectedServers.includes('gcp')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class="droptitle mb-3 mt-3">
                <h4 class="mt-1">GCP cost breakdown summary</h4>
            </div>
            <div class='droptitle'>
                <div class='col'>
                    <div class="row">
                        <div class="col-8">
                            <p>Server</p>
                            <p>Storage</p>
                            <p>Network</p>
                            <!-- <p>IT Labor</p> -->
                        </div>
                        <div class="col-4" style="text-align: right;">
                            <p>${{gcpData?.totalServerCost | number}}</p>
                            <p>${{gcpData?.totalstorageCost | number}}</p>
                            <p>${{gcpData?.totalNetworkingcost | number}}</p>
                            <!-- <p>${{gcpData?.totalitlaborcost | number}}</p> -->
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-8">
                            <p>Total</p>
                        </div>
                        <div class='col-4 input-field _input-field col-2' style="text-align: right;">
                            <p>${{gcpData?.totalCost | number}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

   

    <div class="row mt-3 pl-3">
        <div class="pl-3" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 ' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12' : 'col-lg-3 col-md-3 col-sm-12 col-12'">
            <div class="droptitle">
                <h4 class="mt-1">Estimated on-premises cost ({{Timeframe}} Year(s))</h4>
            </div>
        </div>
        <div class="" *ngIf="shareDataService.selectedServers.includes('azure')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class="droptitle">
                <h4 class="mt-1">Estimated Azure cost ({{Timeframe}} Year(s))</h4>
            </div>
        </div>
        <div class="" *ngIf="shareDataService.selectedServers.includes('aws')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class="droptitle">
                <h4 class="mt-1">Estimated Amazon cost ({{Timeframe}} Year(s))</h4>
            </div>
        </div>
        <div class="" *ngIf="shareDataService.selectedServers.includes('gcp')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class="droptitle">
                <h4 class="mt-1">Estimated GCP cost ({{Timeframe}} Year(s))</h4>
            </div>
        </div>
    </div>



    <div class="row pl-3">

        <div class="pl-3" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12' : 'col-lg-3 col-md-3 col-sm-12 col-12'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row" (click)="onSTOToggleClick('ServerHardwareCosts')">
                        <span class="">
                            
                                <div class='circle' style="text-align: center;">
                                    <img src='../../assets/images/arrow_down.svg' width='14px' height='14px' id='Server"+index+"'
                                        (click)="onToggleClick('this.id')" />
                                </div>
                            
                        </span>
                        <div class="col pl-1 ml-1">
                            <div class="droptitle detail-cost">
                                <h5>On-premises Server Costs</h5>
                                <h5>$ {{totalServerCost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="ServerHardwareCosts droptitle mt-3" *ngIf="descriptiveCost.ServerHardwareCosts">
                        <div>
                            <h4 *ngIf="newResult.VirtualServerHardwareCosts[0]">Virtual Host Sizing for Virtualized Environments</h4>
                            <table class="table-responsive" width="100%" id="customers" *ngIf="newResult.VirtualServerHardwareCosts[0]">
                                <tr class="bold-text">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">App</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;"># VMs</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Host Type</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;"># Cores</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">RAM</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;"># Servers</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">VM Density</th>
                                </tr>
                                <tr *ngFor="let item of newResult.VirtualServerHardwareCosts">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[0].Value}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[1].Value}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[2].Value}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[3].Value}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[4].Value}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[5].Value | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[6].Value}} %</td>
                                </tr>
                            </table>
                            <br  *ngIf="newResult.VirtualServerHardwareCosts[0]"/>
                            <h4>Server Hardware Costs</h4>
                            <table class="table-responsive" width="100%" id="customers">
                                <tr class="bold-text">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;"># of Servers</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;"># of Cores</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">RAM (GB)</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Units (U)</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Power (KW)</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Unit Cost</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Unit Disc.</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Total Cost</th>
                                </tr>
                                <tr *ngFor="let item of newResult.ServerHardwareCostsTableData">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[0].Value}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[1].Value}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[2].Value}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[3].Value}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[4].Value}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{item[5].Value | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item[6].Value}} %</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{item[7].Value | number}}</td>
                                </tr>
                                <tr class="bold-text">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{this.serverCost?.totalServers}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{this.serverCost?.totalUnit}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{this.serverCost?.totalPowser}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{this.serverCost?.totalCost | number}}</td>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <table>
                                <tr *ngFor="let item of newResult.ServerHardwareCosts">
                                    <td width="70%">{{item.Key}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>Rack Infrastructure Costs</h4>
                                    </td>
                                </tr>
                                <tr *ngFor="let item of newResult.RackInfrastructureCosts">
                                    <td width="70%">{{item.Key}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of newResult.TotalRackInfrastructureCosts" class="total-bold-text">
                                    <td width="70%">{{item.Key}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>

                                <tr style="border-bottom: 1px solid #f1f1f1" *ngIf="newResult.VirtualSoftwareCost[0]">
                                    <td colspan="2">
                                        <h4>Virtualization Software Costs</h4>
                                    </td>
                                </tr>
                                <tr *ngFor="let item of newResult.VirtualSoftwareCost">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr style="border-bottom: 1px solid #f1f1f1" *ngIf="newResult.GuestOSLicense[0]">
                                    <td colspan="2">
                                        <h4>Guest OS License</h4>
                                    </td>
                                </tr>
                                <tr *ngFor="let item of newResult.GuestOSLicense">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of newResult.TotalVirtualLicenseAndMaintenanceCost" class="total-bold-text">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>


                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>Server Software Costs (Host OS)</h4>
                                    </td>
                                </tr>
                                <tr *ngFor="let item of newResult.ServerSoftwareCost;let i = index" [ngClass]="{'bold-text': newResult.ServerSoftwareCost.length === 4 && i == 3}">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of newResult.TotalDBSoftwareLicenseCost" class="total-bold-text">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>Facilities Costs (data center space, power and cooling)</h4>
                                    </td>
                                </tr>
                                <tr *ngFor="let item of newResult.FacilitiesCosts">
                                    <td  width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of newResult.TotalFacilitiesCosts" class="total-bold-text">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                        </div>
                        <div *ngIf="newResult.ServerCostBreakDown.length > 0">
                            <h4>Server cost break-down</h4>
                            <table class="table-responsive" width="100%" id="customers">
                                <tr class="bold-text">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Category</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Cost</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">% of Total Cost</th>
                                </tr>
                                <tr>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Hardware</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{newResult.ServerCostBreakDown[0].Value | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{newResult.ServerCostBreakDown[3].Value}} %</td>
                                </tr>
                                <tr>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Software</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{newResult.ServerCostBreakDown[1].Value | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{newResult.ServerCostBreakDown[4].Value}} %</td>
                                </tr>
                                <tr>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Operating Costs (3 Yrs.)</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{newResult.ServerCostBreakDown[2].Value | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{newResult.ServerCostBreakDown[5].Value}} %</td>
                                </tr>
                                <tr class="bold-text">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Total</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{newResult.ServerCostBreakDown[6].Value | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{newResult.ServerCostBreakDown[7].Value}} %</td>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <table>
                                <tr *ngFor="let item of newResult.TotalServerCost" class="bold-text">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="" *ngIf="shareDataService.selectedServers.includes('azure')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row " (click)="onSTOToggleClick('ServerHardwareCosts')">
                        <div class="col">
                            <div class="droptitle detail-cost">
                                <h5>Azure Server Costs</h5>
                                <h5>${{azureData?.totalServerCost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="ServerHardwareCosts droptitle mt-3"  *ngIf="descriptiveCost.ServerHardwareCosts">
                        <div *ngIf="azureData?.VirtualMachinesCost.length > 0 || azureData?.SQLDatabaseCost.length > 0">
                            <!-- <table>
                                
                                <tr *ngFor="let item of azureData?.VirtualMachinesHoursPerMonth">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table> -->
                            <table  *ngIf="azureData?.VirtualMachinesCost.length > 0">
                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>Virtual Machines cost</h4>
                                    </td>
                                </tr>
                            </table>
                            <table class="table-responsive" width="100%" id="customers" *ngIf="azureData?.VirtualMachinesCost.length > 0">
                                <tr class="bold-text">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Instance</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Type</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Number of machine</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hours/Month</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Monthly retail price</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Yearly retail price</th>
                                </tr>
                                <tr *ngFor="let item of azureData?.VirtualMachinesCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Instance}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Type}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.NumberOfVirtualMachines}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.MonthlyHours}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerMonth | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"> {{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerYear | number}}</td>
                                </tr>
                            </table>
                            <table *ngIf="azureData?.TotalVirtualMachinesCost.length > 0">
                                <tr *ngFor="let item of azureData?.TotalVirtualMachinesCost" class="bold-text">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                            <table *ngIf="azureData?.WindowsOSCost.length > 0">
                                <tr *ngFor="let item of azureData?.WindowsOSCost">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                            <table *ngIf="azureData?.SQLDatabaseCost.length > 0">
                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>SQL Server VM Cost</h4>
                                    </td>
                                </tr>
                            </table>
                            <table class="table-responsive" width="100%" id="customers" *ngIf="azureData?.SQLDatabaseCost.length > 0">
                                <tr class="bold-text">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Instance</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Type</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Number of machine</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hours/Month</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Monthly retail price</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Yearly retail price</th>
                                </tr>
                                <tr *ngFor="let item of azureData?.SQLDatabaseCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Instance}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Type}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.NumberOfVirtualMachines}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.MonthlyHours}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerMonth | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"> {{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerYear | number}}</td>
                                </tr>
                            </table>
                            <table  *ngIf="azureData?.TotalSQLDatabaseCost.length > 0">
                                <tr *ngFor="let item of azureData?.TotalSQLDatabaseCost" class="bold-text">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                
                            </table>
                            <table  *ngIf="azureData?.ServerSoftwareCosts.length > 0">
                                <tr *ngFor="let item of azureData?.ServerSoftwareCosts">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                
                            </table>
                            <table  *ngIf="azureData?.TotalAzureComputeCost.length > 0">
                                <tr *ngFor="let item of azureData?.TotalAzureComputeCost" class="bold-text">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                
                            </table>
                            <table *ngIf="azureData?.VirtualMachinesCostNote.length > 0">
                                <tr *ngFor="let item of azureData?.VirtualMachinesCostNote" >
                                    <td colspan="2">{{item.Label}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="" *ngIf="shareDataService.selectedServers.includes('aws')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row " (click)="onSTOToggleClick('ServerHardwareCosts')">
                        <div class="col">
                            <div class="droptitle detail-cost">
                                <h5>AWS Server Costs</h5>
                                <h5>${{awsData?.totalServerCost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="ServerHardwareCosts droptitle mt-3"  *ngIf="descriptiveCost.ServerHardwareCosts">
                        <!-- <div>
                            <h4>{{Timeframe}} Yr. Partial Upfront EC2 Instance Savings Plan</h4>
                            <table class="table-responsive" width="100%" id="customers">
                                <tr>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">AWS Instance</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Upfront</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hourly</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Total Costs</th>
                                </tr>
                                <tr *ngFor="let item of awsData?.UpfrontEC2InstanceSavingPlan">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.AWSInstance}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.UpfrontFee | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.HourlyCost }}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.TotalCost | number}}</td>
                                </tr>
                                <tr class="bold-text">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{awsData?.UpfrontEC2InstanceSavingPlanTotal[0].Label}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{awsData?.UpfrontEC2InstanceSavingPlanTotal[0].Unit === 'USD' ? '$' : awsData?.UpfrontEC2InstanceSavingPlanTotal[0].Unit}} {{awsData?.UpfrontEC2InstanceSavingPlanTotal[0].Value | number}}</td>
                                </tr>
                            </table>
                        </div>

                        <div>
                            <h4>On-Demand</h4>
                            <table class="table-responsive" width="100%" id="customers">
                                <tr>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">AWS Instance</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Upfront</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hourly</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Total Costs</th>
                                </tr>
                                <tr *ngFor="let item of awsData?.OnDemandUtilization">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.AWSInstance}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} -</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.PricePerHr}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.OnDemandTotalCost | number}}</td>
                                </tr>
                                <tr class="bold-text">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{awsData?.OnDemandUtilizationTotal[0].Label}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{awsData?.OnDemandUtilizationTotal[0].Unit === 'USD' ? '$' : awsData?.OnDemandUtilizationTotal[0].Unit}} {{awsData?.OnDemandUtilizationTotal[0].Value | number}}</td>
                                </tr>
                            </table>
                        </div> -->

                        <div>
                            <h4>Lowest Priced Instance</h4>
                            <table class="table-responsive" width="100%" id="customers">
                                <tr>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">AWS Instance</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hours/Month</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hourly</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Cost</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Type</th>
                                </tr>
                                <tr *ngFor="let item of awsData?.LowestPricedInstanceUtilization">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.AWSInstance}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.MonthlyHours}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.PricePerHr}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit }} {{item.Cost | number}} </td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"> {{item.Type}}</td>
                                </tr>
                                <tr class="bold-text">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Total Cost</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{awsData?.EC2Costs[0].Unit === 'USD' ? '$' : awsData?.EC2Costs[0].Unit}} {{awsData?.EC2Costs[0].Value | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"></td>
                                </tr>
                            </table>
                            
                        </div>
                        <div>
                            <table class="table-class">
                                <tr>
                                    <th width="70%">{{awsData?.EC2Costs[0].Label}}</th>
                                    <th align="right">{{awsData?.EC2Costs[0].Unit === 'USD' ? '$' : awsData?.EC2Costs[0].Unit}} {{awsData?.EC2Costs[0].Value | number}}</th>
                                </tr>
                            </table>
                        </div>
                        <!-- <div>
                            <h4>EC2 Instance Savings Plan discounts (if Applicable)</h4>
                        </div>
                        <div>
                            <table  width="100%" id="customers" class="table-responsive">
                                <tr>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">AWS Instance</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Instance type</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;"># Instances</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Upfront fee</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hourly</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Total Cost</th>
                                </tr>
                                <tr *ngFor="let item of awsData?.EC2InstanceSavingsPlan">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.AWSInstance}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.InstanceType}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.PricePerHr}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.UpfrontFee | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.HourlyCost | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.TotalCost | number}}</td>
                                </tr>
                                
                            </table>
                            <table >
                                <tr class="bold-text">
                                    <td >{{awsData?.TotalEC2InstanceSavingsPlan[0].Label}}</td>
                                    <td align="right">{{awsData?.TotalEC2InstanceSavingsPlan[0].Unit === 'USD' ? '$' : awsData?.TotalEC2InstanceSavingsPlan[0].Unit}} {{awsData?.TotalEC2InstanceSavingsPlan[0].Value | number}}</td> 
                                </tr>
                            </table>
                        </div> -->
                        <div>
                            <table >
                                <tr>
                                    <td >{{awsData?.DiscountTierApplicable[0].Label}}</td>
                                    <td align="right">{{awsData?.DiscountTierApplicable[0].Value}}%</td> 
                                </tr>
                                <tr class="bold-text">
                                    <td >{{awsData?.TotalDiscountAndSupport[0].Label}}</td>
                                    <td align="right">$ {{awsData?.TotalDiscountAndSupport[0].Value | number}}</td> 
                                </tr>
                            </table>
                            <table class="table-class" *ngIf="awsData?.TotalDiscountAndSupport.length > 1">
                                <tr>
                                    <th width="70%">{{awsData?.TotalDiscountAndSupport[1].Label}}</th>
                                    <th align="right">{{awsData?.TotalDiscountAndSupport[1].Unit === 'USD' ? '$' : awsData?.TotalDiscountAndSupport[1].Unit}} {{awsData?.TotalDiscountAndSupport[1].Value | number}}</th>
                                </tr>
                            </table>
                        </div>
                        <div *ngIf="awsData?.ServerSoftwareCosts.length > 0 && awsData?.ServerSoftwareCosts[0]?.Value != 0">
                            <table  class="table-class">
                                <h4>Server Software Costs (BYOL Only)</h4>
                                <tr *ngFor="let item of awsData?.ServerSoftwareCosts">
                                    <th >{{item.Label}}</th>
                                    <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th> 
                                </tr>
                            </table>
                        </div>
                        <div *ngIf="awsData?.CloudWatchMetrics">
                            <table >
                                <tr *ngFor="let item of awsData?.CloudWatchMetrics">
                                    <td>{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                            <table class="table-class" *ngIf="awsData?.TotalCloudWatchMetrics.length > 0">
                                <tr>
                                    <th width="70%">{{awsData?.TotalCloudWatchMetrics[0].Label}}</th>
                                    <th align="right">{{awsData?.TotalCloudWatchMetrics[0].Unit === 'USD' ? '$' : awsData?.TotalCloudWatchMetrics[0].Unit}} {{awsData?.TotalCloudWatchMetrics[0].Value | number}}</th>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="" *ngIf="shareDataService.selectedServers.includes('gcp')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row " (click)="onSTOToggleClick('ServerHardwareCosts')">
                        <div class="col">
                            <div class="droptitle detail-cost">
                                <h5>GCP Server Costs</h5>
                                <h5>${{gcpData?.totalServerCost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="ServerHardwareCosts droptitle mt-3"  *ngIf="descriptiveCost.ServerHardwareCosts">
                        <div *ngIf="gcpData?.VirtualMachinesCost.length > 0 || gcpData?.SQLDatabaseCost.length > 0">
                            <!-- <table>
                                
                                <tr *ngFor="let item of gcpData?.VirtualMachinesHoursPerMonth">
                                    <td>{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table> -->
                            <table *ngIf="gcpData?.VirtualMachinesCost.length > 0">
                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>Virtual Machines cost</h4>
                                    </td>
                                </tr>
                            </table>
                            <table class="table-responsive" width="100%" id="customers" *ngIf="gcpData?.VirtualMachinesCost.length > 0">
                                <tr class="bold-text">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Instance</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Type</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Number of machine</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hours/Month</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Monthly retail price</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Yearly retail price</th>
                                </tr>
                                <tr *ngFor="let item of gcpData?.VirtualMachinesCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Instance}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Type}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.NumberOfVirtualMachines}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.MonthlyHours}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerMonth | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"> {{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerYear | number}}</td>
                                </tr>
                            </table>
                            <table *ngIf="gcpData?.TotalVirtualMachinesCost.length > 0">
                                <tr *ngFor="let item of gcpData?.WindowsOSCost">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of gcpData?.TotalVirtualMachinesCost" class="bold-text">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                            <table  *ngIf="gcpData?.SQLDatabaseCost.length > 0">
                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>SQL Server VM Cost</h4>
                                    </td>
                                </tr>
                            </table>
                            <table class="table-responsive" width="100%" id="customers" *ngIf="gcpData?.SQLDatabaseCost.length > 0">
                                <tr class="bold-text">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Instance</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Type</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Number of machine</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Hours/Month</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Monthly retail price</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Yearly retail price</th>
                                </tr>
                                <tr *ngFor="let item of gcpData?.SQLDatabaseCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Instance}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Type}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.NumberOfVirtualMachines}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.MonthlyHours}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerMonth | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;"> {{item.Unit === 'USD' ? '$' : item.Unit}} {{item.VirtualMachineCostPerYear | number}}</td>
                                </tr>
                            </table>
                            <table  *ngIf="gcpData?.TotalSQLDatabaseCost.length > 0">
                                <tr  *ngFor="let item of gcpData?.SQLWindowsOSCost">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of gcpData?.SQLStandardCost">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of gcpData?.SQLEnterpriseCost">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of gcpData?.TotalSQLDatabaseCost" class="bold-text">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                
                            </table>
                            <table *ngIf="gcpData?.VirtualMachinesCostNote.length > 0">
                                <tr *ngFor="let item of gcpData?.VirtualMachinesCostNote" >
                                    <td colspan="2">{{item.Label}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- RackInfrastructureCosts -->


        <div class="col-lg-3 col-md-4 col-sm-12 col-12 pl-3" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12' : 'col-lg-3 col-md-3 col-sm-12 col-12'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row" (click)="onSTOToggleClick('Storage')">
                        <span class="">
                            
                                <div class='circle' style="text-align: center;">
                                    <img src='../../assets/images/arrow_down.svg' width='14px' height='14px' id='Server"+index+"'
                                        (click)="onToggleClick('this.id')" />
                                </div>
                            
                        </span>
                        <div class="col pl-1 ml-1">
                            <div class="droptitle detail-cost">
                                <h5>On-premises Storage Cost</h5>
                                <h5>$ {{totalstorageCost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="RackInfrastructureCosts droptitle mt-3" *ngIf="descriptiveCost.Storage">
                        <div>
                            <table>
                                <h4 *ngIf="newResult.StorageSANCost.length > 0">SAN Cost</h4>
                                <tr *ngFor="let item of newResult.StorageSANCost">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of newResult.TotalStorageSANCost" class="total-bold-text">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>

                                <h4 *ngIf="newResult.StorageBackupCost.length > 0">Storage backup cost</h4>
                                <tr *ngFor="let item of newResult.StorageBackupCost">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right" *ngIf="item.Label === 'Type of Tape Library used'">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value}}</td>
                                    <td align="right" *ngIf="item.Label !== 'Type of Tape Library used'">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of newResult.TotalStorageBackupCost" class="total-bold-text">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>

                                <h4 *ngIf="newResult.StorageOverheadCost.length > 0">Storage Overhead cost (data center space, power, cooling, storage administrator)</h4>
                                <tr *ngFor="let item of newResult.StorageOverheadCost">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of newResult.TotalStorageOverheadCost" class="total-bold-text">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>

                                <tr *ngFor="let item of newResult.TotalDatacenterSpacePowerCoolingCost" class="total-bold-text">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>





                                <!-- <tr *ngFor="let item of newResult.StorageCostBreakDown">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Cost | number}}</td>
                                </tr> -->
                            </table>
                        </div>
                        <div *ngIf="newResult.ServerCostBreakDown.length > 0">
                            <h4>Storage cost break-down</h4>
                            <table class="table-responsive" width="100%" id="customers">
                                <tr class="bold-text">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Category</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Cost</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">% of Total Cost</th>
                                </tr>
                                <tr *ngFor="let item of newResult.StorageCostBreakDown">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">$ {{item.Cost}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.PercentageOfTotalCost}}</td>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <table>
                                <tr *ngFor="let item of newResult.TotalStorageCost" class="total-bold-text">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-md-4 col-sm-12 col-12" *ngIf="shareDataService.selectedServers.includes('azure')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row " (click)="onSTOToggleClick('Storage')">
                        <div class="col">
                            <div class="droptitle detail-cost">
                                <h5>Azure Storage</h5>
                                <h5>${{azureData?.totalstorageCost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="RackInfrastructureCosts droptitle mt-3" *ngIf="descriptiveCost.Storage">
                        <div *ngIf="azureData?.PageBlobStorageCost.length > 0">
                            <table>
                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>Page Blob storage</h4>
                                    </td>
                                </tr>
                                <tr *ngFor="let item of azureData?.PageBlobStorageCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                </tr>
                                <tr *ngFor="let item of azureData?.TotalPageBlobStorageCost" class="bold-text">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                </tr>
                            </table>
                        </div>
                        <div *ngIf="azureData?.PremiumStorageCost.length > 0">
                            <table>
                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>Premium storage</h4>
                                    </td>
                                </tr>
                                <tr *ngFor="let item of azureData?.PremiumStorageCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                </tr>
                                <tr *ngFor="let item of azureData?.TotalPremiumStorageCost" class="bold-text">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                </tr>
                            </table>
                        </div>
                            <div *ngIf="azureData?.FileStorageCost.length > 0">
                                <table>
                                    <tr style="border-bottom: 1px solid #f1f1f1">
                                        <td colspan="2">
                                            <h4>File storage</h4>
                                        </td>
                                    </tr>
                                    <tr *ngFor="let item of azureData?.FileStorageCost">
                                        <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                        <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                    </tr>
                                    <tr *ngFor="let item of azureData?.TotalFileStorageCost" class="bold-text">
                                        <td >{{item.Label}}</td>
                                        <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                    </tr>
                                </table>
                            </div>
                            <div *ngIf="azureData?.BlockBlobStorageHotTier.length > 0">
                                <table>
                                    <tr style="border-bottom: 1px solid #f1f1f1">
                                        <td colspan="2">
                                            <h4>Block Blob storage Hot tier</h4>
                                        </td>
                                    </tr>
                                    <tr *ngFor="let item of azureData?.BlockBlobStorageHotTier">
                                        <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                        <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                    </tr>
                                    <tr *ngFor="let item of azureData?.TotalBlockBlobStorageHotTier" class="bold-text">
                                        <td >{{item.Label}}</td>
                                        <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                    </tr>
                                </table>
                            </div>
                            <div *ngIf="azureData?.BlockBlobStorageCoolTier.length > 0">
                                <table>
                                    <tr style="border-bottom: 1px solid #f1f1f1">
                                        <td colspan="2">
                                            <h4>Block Blob storage Cool tier</h4>
                                        </td>
                                    </tr>
                                    <tr *ngFor="let item of azureData?.BlockBlobStorageCoolTier">
                                        <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                        <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                    </tr>
                                    <tr *ngFor="let item of azureData?.TotalBlockBlobStorageCoolTier" class="bold-text">
                                        <td >{{item.Label}}</td>
                                        <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                    </tr>
                                </table>
                            </div>
                            <!-- <div *ngIf="azureData?.SQLDatabaseCost.length > 0">
                                <table class="table-responsive">
                                    <tr style="border-bottom: 1px solid #f1f1f1">
                                        <td colspan="2">
                                            <h4>SQL Server VM storage cost</h4>
                                        </td>
                                    </tr>
                                    <tr *ngFor="let item of azureData?.SQLDatabaseCost">
                                        <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                        <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                    </tr>
                                    <tr *ngFor="let item of azureData?.TotalSQLDatabaseCost" class="bold-text">
                                        <td >{{item.Label}}</td>
                                        <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                    </tr>
                                </table>
                            </div> -->
                            <div *ngIf="azureData?.SQLServerVMStorageCost.length > 0">
                            <table >
                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>SQL Server VM storage cost</h4>
                                    </td>
                                </tr>
                            </table>
                            <table class="table-responsive" width="100%" id="customers" *ngIf="azureData?.SQLServerVMStorageCost.length > 0">
                                <tr class="bold-text">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Azure disk</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Usable Storage Volume(GB)</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Disk price per month</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Number of disks</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Total IOPS</th>
                                </tr>
                                <tr *ngFor="let item of azureData?.SQLServerVMStorageCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.AzureDiskMatch}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.UsableStorageVolumeGB}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.DiskPricePerMonth | number}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.NumberOfDisks}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.TotalIOPS}}</td>
                                </tr>
                            </table>
                            <table  *ngIf="azureData?.TotalSQLServerVMStorageCost.length > 0">
                                <tr *ngFor="let item of azureData?.TotalSQLServerVMStorageCost" class="bold-text">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                
                            </table>
                        </div>
                            <div *ngIf="azureData?.TotalStorageCost.length > 0">
                                <table>
                                    <tr *ngFor="let item of azureData?.TotalStorageCost" class="bold-text">
                                        <td >{{item.Label}}</td>
                                        <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                    </tr>
                                </table>
                            </div>
                        
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-md-4 col-sm-12 col-12" *ngIf="shareDataService.selectedServers.includes('aws')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row " (click)="onSTOToggleClick('Storage')">
                        <div class="col">
                            <div class="droptitle detail-cost">
                                <h5>AWS Storage</h5>
                                <h5>${{awsData?.totalstorageCost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="RackInfrastructureCosts droptitle mt-3" *ngIf="descriptiveCost.Storage">
                        <div *ngIf="awsData?.EBSCostEquivalentToSAN && awsData?.EBSCostEquivalentToSAN.length > 0">
                            <h4>EBS Storage - Only Standard EBS used with no IOPS requirements</h4>
                            <table>
                                <h4>EBS Costs - Equivalent to On-Premises SAN environment</h4>
                                <tr *ngFor="let item of awsData?.EBSCostEquivalentToSAN">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.value | number) : item.value}}</td>
                                </tr>
                                <tr *ngFor="let item of awsData?.TotalEBSCostEquivalentToSAN" class="bold-text">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                        </div>

                        <div *ngIf="awsData?.EFSCostEquivalentToNAS && awsData?.EFSCostEquivalentToNAS.length > 0">
                            <table>
                                <h4>EFS Costs -Equivalent to on-premises NAS Storage</h4>
                                <tr *ngFor="let item of awsData?.EFSCostEquivalentToNAS">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                </tr>
                                <tr *ngFor="let item of awsData?.TotalEFSCostEquivalentToNAS" class="bold-text">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>

                                
                            </table>
                        </div>
                        <div *ngIf="awsData?.S3StandardInfrequentCostsStorageGB && awsData?.S3StandardInfrequentCostsStorageGB.length > 0">
                            <h4>S3 Standard – Infrequent Access Costs -Equivalent to on-premises Object Storage</h4>
                            <table>
                                <tr *ngFor="let item of awsData?.S3StandardInfrequentCostsStorageGB">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Value}}</td>
                                </tr>
                            </table>
                                <table width="100%" id="customers">
                                    <tr>
                                        <th colspan="2" align="center">
                                            S3 Standard – Infrequent Access storage cost
                                        </th>
                                    </tr>
                                    <tr>
                                        <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Tier</th>
                                        <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Cost</th>
                                    </tr>
                                    <tr *ngFor="let item of awsData?.S3StandardInfrequentCosts">
                                        <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Tier}}</td>
                                        <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Cost}}</td>
                                    </tr>
                                </table>
                                <table>
                                    <tr *ngFor="let item of awsData?.AWSBusinessSupportS3StandardInfrequent">
                                        <td width="70%">{{item.Label}}</td>
                                        <td align="right">{{item.Value}}</td>
                                    </tr>
                                </table>
                        </div>

                        <div *ngIf="awsData?.TotalAWSStorageCostIncludingSupport && awsData?.TotalAWSStorageCostIncludingSupport.length>0">
                            <table>
                                <tr *ngFor="let item of awsData?.TotalAWSStorageCostIncludingSupport" class="total-bold-text">
                                    <td width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <!-- <div *ngIf="awsData?.EFSCostEquivalentToNAS">
                        <h4>Support Costs - All Services</h4>
                            <table class="table-responsive" width="100%" id="customers">
                                <tr>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Business Level Support</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Cost</th>
                                </tr>
                                <tr *ngFor="let item of awsData?.SupportCostAllServices">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                    </div> -->
                    
                </div>
            </div>
        </div>
        
        <div class="col-lg-3 col-md-4 col-sm-12 col-12" *ngIf="shareDataService.selectedServers.includes('gcp')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row " (click)="onSTOToggleClick('Storage')">
                        <div class="col">
                            <div class="droptitle detail-cost">
                                <h5>GCP Storage</h5>
                                <h5>${{gcpData?.totalstorageCost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="RackInfrastructureCosts droptitle mt-3" *ngIf="descriptiveCost.Storage">
                        <div *ngIf="gcpData?.HDDPersistentDiskCost.length > 0 || gcpData?.SSDPersistentDiskCost.length > 0">
                            <table>
                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>Persistent Disk Storage</h4>
                                    </td>
                                </tr>
                                <tr *ngFor="let item of gcpData?.HDDPersistentDiskCost">
                                    <td >{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                </tr>
                                <tr *ngFor="let item of gcpData?.SSDPersistentDiskCost">
                                    <td >{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                </tr>
                            </table>
                        </div>

                        <div *ngIf="gcpData?.FileStoreCost.length > 0">
                            <table>
                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>File Store Storage</h4>
                                    </td>
                                </tr>
                                <tr *ngFor="let item of gcpData?.FileStoreCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                </tr>
                            </table>
                        </div>

                        <div *ngIf="gcpData?.GCSCost.length > 0">
                            <table >
                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>Google Cloud Storage</h4>
                                    </td>
                                </tr>
                                <tr *ngFor="let item of gcpData?.GCSCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                </tr>
                            </table>
                        </div>

                        <div *ngIf="gcpData?.TotalGCPStorageCost.length > 0">
                            <table>
                                <tr *ngFor="let item of gcpData?.TotalGCPStorageCost" class="bold-text">
                                    <td >{{item.Label}}</td>
                                    <td align="right" >{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Unit === 'USD' ? (item.Value | number) : item.Value}}</td>
                                </tr>
                            </table>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>

        <!-- Networking -->


        <div class="col-lg-3 col-md-4 col-sm-12 col-12" *ngIf="false">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row" (click)="onSTOToggleClick('FacilitiesCosts')">
                        <span class="">
                            
                                <div class='circle'  style="text-align: center;">
                                    <img src='../../assets/images/arrow_down.svg' width='14px' height='14px' id='Server"+index+"'
                                        (click)="onToggleClick('this.id')" />
                                </div>
                            
                        </span>
                        <div class="col  pl-1 ml-1">
                            <div class="droptitle">
                                <h5>Facilities Costs (data center space, power and cooling)</h5>
                            </div>
                        </div>
                    </div>
                    <div class="networkingCost droptitle mt-3" *ngIf="descriptiveCost.FacilitiesCosts">
                        <div>
                            <table>
                                <tr *ngFor="let item of newResult.FacilitiesCosts">
                                    <td  width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-4 pl-3" *ngIf="false">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row " (click)="onSTOToggleClick('networkingCost')">
                        <div class="col">
                            <div class="droptitle">
                                <h5>Azure networking cost</h5>
                            </div>
                        </div>
                    </div>
                    <div class="networkingCost droptitle mt-3" style="display: none;">
                        <div>
                            <table>
                                <tr>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Total outgoing bandwidth needed per month</td>
                                    <td align="right">1 GB</td>
                                </tr>
                                <tr>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Total outgoing bandwidth cost per month</td>
                                    <td align="right">$0.00</td>
                                </tr>
                                <tr style="border-top: 1px solid #f1f1f1">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Total Azure networking cost over five year(s)</td>
                                    <td align="right">$0.00</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-4 " *ngIf="false">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row " (click)="onSTOToggleClick('networkingCost')">
                        <div class="col">
                            <div class="droptitle">
                                <h5>AWS Networking cost</h5>
                            </div>
                        </div>
                    </div>
                    <div class="networkingCost droptitle mt-3" style="display: none;">
                        <div>
                            <table >
                                <tr>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{awsData?.MonthlyDataTransferOut[0].Label}}</td>
                                    <td align="right">{{awsData?.MonthlyDataTransferOut[0].Label}}</td>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <h4>Data Transfer Costs</h4>
                            <table class="table-responsive" width="100%" id="customers">
                                <tr>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;"></th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">US West (Oregon)</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Tier(GB)</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Monthly Cost</th>
                                </tr>
                                <tr *ngFor="let item of awsData?.DataTransferCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.DataTransfer}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Rate}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Tier}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.MonthlyCost}}</td>
                                </tr>
                            </table>
                            <table class="table-responsive" class="table-class">
                                <tr *ngFor="let item of awsData?.TotalDataTransferCost">
                                    <th >{{item.Label}}</th>
                                    <th>{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Storage -->


        <div class="pl-3" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12' : 'col-lg-3 col-md-3 col-sm-12 col-12'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row" (click)="onSTOToggleClick('NetworkAdminCost')">
                        <span class="">
                            
                                <div class='circle' style="text-align: center; ">
                                    <img src='../../assets/images/arrow_down.svg' width='14px' height='14px' id='Server"+index+"'
                                        (click)="onToggleClick('this.id')" />
                                </div>
                            
                        </span>
                        <div class="col  pl-1 ml-1">
                            <div class="droptitle detail-cost">
                                <h5>On-premises Network Cost</h5>
                                <h5>$ {{totalNetworkingcost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="storageCost droptitle mt-3" *ngIf="descriptiveCost.NetworkAdminCost">
                        <div>
                            <table>
                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>Networking Hardware and Software Costs</h4>
                                    </td>
                                </tr>
                                <tr *ngFor="let item of newResult.NetworkHardwareAndSoftwareCost">
                                    <td  width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of newResult.TotalNetworkHardwareAndSoftwareCost" class="total-bold-text">
                                    <td  width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>

                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>Bandwidth Costs (On-Premises)</h4>
                                    </td>
                                </tr>
                                <tr *ngFor="let item of newResult.OnPremisesBandwidthCost">
                                    <td  width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of newResult.TotalOnPremisesBandwidthCost" class="total-bold-text">
                                    <td  width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>

                                <tr style="border-bottom: 1px solid #f1f1f1">
                                    <td colspan="2">
                                        <h4>Network Admin Costs</h4>
                                    </td>
                                </tr>
                                <tr *ngFor="let item of newResult.NetworkAdminCost">
                                    <td  width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of newResult.TotalNetworkCost" class="total-bold-text">
                                    <td  width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="" *ngIf="shareDataService.selectedServers.includes('azure')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row " (click)="onSTOToggleClick('NetworkAdminCost')">
                        <div class="col">
                            <div class="droptitle detail-cost">
                                <h5>Azure Network</h5>
                                <h5>${{azureData?.totalNetworkingcost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="storageCost droptitle mt-3" *ngIf="descriptiveCost.NetworkAdminCost">
                        <div>
                            <table>
                                <tr *ngFor="let item of azureData?.NetworkingOutgoingBandwidth">
                                    <td >{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of azureData?.TotalNetworkCost" class="total-bold-text">
                                    <td >{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="" *ngIf="shareDataService.selectedServers.includes('aws')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row " (click)="onSTOToggleClick('NetworkAdminCost')">
                        <div class="col">
                            <div class="droptitle detail-cost">
                                <h5>AWS Network</h5>
                                <h5>${{awsData?.totalNetworkingcost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="storageCost droptitle mt-3" *ngIf="descriptiveCost.NetworkAdminCost">
                        <div>
                            <h4>Data Transfer Costs</h4>
                            <table  *ngIf="awsData?.MonthlyDataTransferOut && awsData?.MonthlyDataTransferOut.length > 0">
                                <tr>
                                    <td>{{awsData?.MonthlyDataTransferOut[0].Label}}</td>
                                    <td align="right">{{awsData?.MonthlyDataTransferOut[0].Value}}</td>
                                </tr>
                             </table>
                            
                            <table class="table-responsive" width="100%" id="customers">
                                <tr>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;"></th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">US West (Oregon)</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Tier(GB)</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Monthly Cost</th>
                                </tr>
                                <tr *ngFor="let item of awsData?.DataTransferCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.DataTransfer}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Rate}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Tier}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.MonthlyCost}}</td>
                                </tr>
                            </table>
                            <table class="table-responsive" class="table-class">
                                <tr *ngFor="let item of awsData?.TotalDataTransferCost">
                                    <th >{{item.Label}}</th>
                                    <th>{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="" *ngIf="shareDataService.selectedServers.includes('gcp')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row " (click)="onSTOToggleClick('NetworkAdminCost')">
                        <div class="col">
                            <div class="droptitle detail-cost">
                                <h5>GCP Network</h5>
                                <h5>${{gcpData?.totalNetworkingcost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="storageCost droptitle mt-3" *ngIf="descriptiveCost.NetworkAdminCost">
                        <div>
                            <table>
                                <tr *ngFor="let item of gcpData?.NetworkingOutgoingBandwidth">
                                    <td >{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of gcpData?.TotalNetworkCost" class="total-bold-text">
                                    <td >{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- IT Labour -->


        <!-- <div class="col-lg-3 col-md-4 col-sm-12 col-12 pl-3" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row" (click)="onSTOToggleClick('ITLaborDatabaseAdminCost')">
                        <span class="pl-3">
                            
                                <div class='circle' style="text-align: center; ">
                                    <img src='../../assets/images/arrow_down.svg' width='14px' height='14px' id='Server"+index+"'
                                        (click)="onToggleClick('this.id')" />
                                </div>
                            
                        </span>
                        <div class="col pl-1 ml-1">
                            <div class="droptitle detail-cost">
                                <h5>on-premises IT Labour cost</h5>
                                <h5>$ {{totalitlaborcost | number}}</h5>
                            </div>  
                        </div>
                    </div>
                    <div class="itLabour droptitle mt-3" *ngIf="descriptiveCost.ITLaborDatabaseAdminCost">
                        <div>
                            <table class="table-responsive">
                                <tr *ngFor="let item of newResult.ITLaborNonDatabaseAdminCost">
                                    <td  width="70%">{{item.Label}}</td>
                                    <td align="right"> {{item.Unit === 'USD' ? '$' : item.Unit}}{{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of newResult.ITLaborDatabaseAdminCost">
                                    <td  width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>

                                <tr *ngFor="let item of newResult.TotalITLaborNonDatabaseAdminCost" class="bold-text">
                                    <td  width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of newResult.ITLaborTotalCost" class="total-bold-text">
                                    <td  width="70%">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-md-4 col-sm-12 col-12 pl-3" *ngIf="shareDataService.selectedServers.includes('azure')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row " (click)="onSTOToggleClick('ITLaborDatabaseAdminCost')">
                        <div class="col">
                            <div class="droptitle detail-cost">
                                <h5>Azure IT Labor cost</h5>
                                <h5>${{azureData?.totalitlaborcost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="itLabour droptitle mt-3" *ngIf="descriptiveCost.ITLaborDatabaseAdminCost">
                        <div>
                            <table class="table-responsive">
                                <tr *ngFor="let item of azureData?.ITLaborCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                                <tr *ngFor="let item of azureData?.TotalITLaborCost" class="total-bold-text">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-md-4 col-sm-12 col-12 pl-3" *ngIf="shareDataService.selectedServers.includes('aws')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row " (click)="onSTOToggleClick('ITLaborDatabaseAdminCost')">
                        <div class="col">
                            <div class="droptitle detail-cost">
                                <h5>AWS IT Labor cost</h5>
                                <h5>${{awsData?.totalitlaborcost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="itLabour droptitle mt-3" *ngIf="descriptiveCost.ITLaborDatabaseAdminCost">
                        <div>
                            <table class="table-responsive">
                                <h4>EC2 Admin Costs</h4>
                                <tr *ngFor="let item of awsData?.ITLaborEC2AdminCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                            <table class="table-responsive" class="table-class">
                                <tr *ngFor="let item of awsData?.TotalITLaborEC2AdminCost">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                                    <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <table class="table-responsive">
                                <tr *ngFor="let item of awsData?.ITLaborRDSAdminCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                            <table class="table-responsive" class="table-class">
                                <tr *ngFor="let item of awsData?.TotalITLaborRDSAdminCost">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                                    <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                                </tr>
                            </table>
                            <table class="table-responsive" class="table-class">
                                <tr *ngFor="let item of awsData?.TotalITAdminCostBasedOnVMsServers">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                                    <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <h4>AWS - Support Costs</h4>
                            <table class="table-responsive">
                                <tr *ngFor="let item of awsData?.AWSSupportCost">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                    <td align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                            <table class="table-responsive" class="table-class">
                                <tr *ngFor="let item of awsData?.TotalMonthlyAwsSpend">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                                    <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <h4>Support Costs - All Services</h4>
                            <table class="table-responsive" width="100%" id="customers">
                                <tr>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Business Level Support</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Cost</th>
                                </tr>
                                <tr *ngFor="let item of awsData?.SupportCostAllServices">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <table class="table-responsive" class="table-class">
                                <tr *ngFor="let item of awsData?.TotalSupportCostAllServices">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                                    <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                                </tr>
                            </table>
                            <table class="table-responsive" class="table-class">
                                <tr *ngFor="let item of awsData?.EC2ReservedInstancesUpfrontCostAfterDisc">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                                    <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                                </tr>
                            </table>    
                        </div>
                        <div>
                            <h4>Support Costs - Reserved Instances</h4>
                            <table class="table-responsive" width="100%" id="customers">
                                <tr>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Business Level Support</th>
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">Cost</th>
                                </tr>
                                <tr *ngFor="let item of awsData?.SupportCostReservedInstances">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</td>
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</td>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <table class="table-responsive" class="table-class">
                                <tr *ngFor="let item of awsData?.TotalSupportCostReservedInstances">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                                    <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                                </tr>
                            </table>
                            <table class="table-responsive" class="table-class">
                                <tr *ngFor="let item of awsData?.TotalAwsSupportCostBusiness">
                                    <th style="min-width: 62px; width: auto !important; white-space: nowrap;">{{item.Label}}</th>
                                    <th align="right">{{item.Unit === 'USD' ? '$' : item.Unit}} {{item.Value | number}}</th>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-md-4 col-sm-12 col-12 pl-3" *ngIf="shareDataService.selectedServers.includes('gcp')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class='mt-3'>
                <div>
                    <div id='"divf1"' class="row " (click)="onSTOToggleClick('ITLaborDatabaseAdminCost')">
                        <div class="col">
                            <div class="droptitle detail-cost">
                                <h5>GCP IT Labor cost</h5>
                                <h5>${{gcpData?.totalitlaborcost | number}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="itLabour droptitle mt-3" *ngIf="descriptiveCost.ITLaborDatabaseAdminCost">
                        <div>
                            <table class="table-responsive">
                                <tr class="bold-text">
                                    <td style="min-width: 62px; width: auto !important; white-space: nowrap;">Total GCP IT Labor Cost</td>
                                    <td align="right">$ {{gcpData?.totalNetworkingcost | number}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- End -->

    </div>

    <div class="row mt-3 pl-3">
        <div class="pl-3" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12' : 'col-lg-3 col-md-3 col-sm-12 col-12'">
            <div class="droptitle final-total">
                <table>
                    <tr>
                        <td>
                            <h5>Total on-premises cost over {{Timeframe}} year(s)</h5>
                        </td>
                        <td align="right">
                            <h5>$ {{
                                totalCost | number
                            }}</h5>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="" *ngIf="shareDataService.selectedServers.includes('azure')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class="droptitle final-total">
                <table >
                    <tr>
                        <td >
                            <h5>Total Azure cost over {{Timeframe}} year(s)</h5>
                        </td>
                        <td align="right">
                            <h5>$ {{azureData?.totalCost | number}}</h5>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="" *ngIf="shareDataService.selectedServers.includes('aws')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class="droptitle final-total">
                <table >
                    <tr>
                        <td >
                            <h5>Total Amazon cost over {{Timeframe}} year(s)</h5>
                        </td>
                        <td align="right">
                            <h5>$ {{awsData?.totalCost | number}}</h5>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="" *ngIf="shareDataService.selectedServers.includes('gcp')" [ngClass]="sectionCount == 2 ? 'col-lg-6 col-md-6 col-sm-12 col-12 pl-3' : sectionCount == 3 ? 'col-lg-4 col-md-4 col-sm-12 col-12  pl-3' : 'col-lg-3 col-md-3 col-sm-12 col-12  pl-3'">
            <div class="droptitle final-total">
                <table >
                    <tr>
                        <td>
                            <h5>Total GCP cost over {{Timeframe}} year(s)</h5>
                        </td>
                        <td align="right">
                            <h5>$ {{gcpData?.totalCost | number}}</h5>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>




    <section>
        <div class="row justify-content-center mt-5">

            <ul class="actions mr-3">
                <li><a  class="button special">Contact me</a></li>
            </ul>
            <ul class="actions mr-3">
                <li>
                    <a  class="button alt" (click)="pdfReport()">Download Report</a>
                    <!-- <a *ngIf="shareDataService.setep3?.IsUserDataProvied" class="button alt" (click)="pdfReport()">Download Report</a> -->
                    <!-- <a *ngIf="!shareDataService.setep3?.IsUserDataProvied" class="button alt" data-toggle="modal" data-target="#myModal">Download Report</a> -->
                </li>
            </ul>
            <ul class="actions mr-3">
                <li><a class="button alt" style="padding-left: 60px; padding-right: 60px;" (click)="back()">Back</a></li>
            </ul>
        </div>
    </section>

</section>

<section>
    <div class="Orange blog mt-5" style="text-align: center;">
        
        <h3 style="color: #fff;">Help us improve. Is the TCO calculator helpful?</h3>
        <div class="mt-4">
            <span class="actions m-2">
                <a class="button alt white">Next</a>
            </span>
            <span class="actions m-2">
                <a class="button alt white">No</a>
            </span>
        </div>
    
</div>
</section>

<div class="modal" id="myModal">
    <div class="">
       <div class="modal-content">
          <div class="modal-header">
             <h4 style="margin-bottom: 0px;">Get Your Full Report Now</h4>
             <button type="button" class="close" data-dismiss="modal" style="padding: 0px; margin: 0px; height: 20px;">&times;</button>
          </div>
          <div class="modal-body" style="overflow: hidden; height: 480px;">
                <div class="row">
                   <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <div class="form-group">
                         <label for="firstname">First Name <span>*</span></label>
                         <input type="text" class="form-control" id="firstname" [(ngModel)]="customerData.FirstName">
                      </div>
                   </div>
                   <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <div class="form-group">
                         <label for="lastname">Last Name <span>*</span></label>
                         <input type="text" class="form-control" id="lastname" [(ngModel)]="customerData.LastName">
                      </div>
                   </div>
                   <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <div class="form-group">
                         <label for="phone">Phone Number <span>*</span></label>
                         <input type="text" class="form-control" id="phone" [(ngModel)]="customerData.PhoneNumber">
                      </div>
                   </div>
                   <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <div class="form-group">
                         <label for="email">Email <span>*</span></label>
                         <input type="email" class="form-control" id="email" [(ngModel)]="customerData.Email">
                      </div>
                   </div>
                   <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <div class="form-group">
                         <label for="jobtitle">Job Title <span>*</span></label>
                         <input type="text" class="form-control" id="jobtitle" [(ngModel)]="customerData.JobTitle">
                      </div>
                   </div>
                   <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <div class="form-group">
                         <label for="company">Company <span>*</span></label>
                         <input type="text" class="form-control" id="company" [(ngModel)]="customerData.Company">
                      </div>
                   </div>
                   <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <div class="form-group">
                         <label for="company">Company Size <span>*</span></label>
                         <select class="form-control" name="employees" id="employees">
                            <option value="false">---- Select ----</option>
                            <option value="1-19 Employees">1-19 Employees</option>
                            <option value="20-99 Employees">20-99 Employees</option>
                      <option value="100-499 Employees">100-499 Employees</option>
                      <option value="500-999 Employees">500-999 Employees</option>
                      <option value="1000-9999 Employees">1000-9999 Employees</option>
                      <option value="10000 Employees or More">10000 Employees or More</option>
                         </select>
                      </div></div> 
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <div class="form-group">
                         <label for="company">Industry <span>*</span></label>
                         <select class="form-control" name="industry" id="industry">
                      <option value="false">- select -</option>
                             <option value="Agriculture">Agriculture</option>
                             <option value="Automotive">Automotive</option>
                             <option value="Computers & Electronics">Computers & Electronics</option>
                             <option value="Consumer Goods">Consumer Goods</option>
                             <option value="Education">Education</option>
                             <option value="Financial Services">Financial Services</option>
                             <option value="Gaming">Gaming</option>
                             <option value="Government">Government</option>
                             <option value="Healthcare">Healthcare</option>
                             <option value="Hospitality">Hospitality</option>
                             <option value="Life Sciences">Life Sciences</option>
                             <option value="Manufacturing">Manufacturing</option>
                             <option value="Marketing & Advertising">Marketing & Advertising</option>
                             <option value="Media & Entertainment">Media & Entertainment</option>
                             <option value="Mining">Mining</option>
                             <option value="Non-Profit Organization">Non-Profit Organization</option>
                             <option value="Oil & Gas">Oil & Gas</option>
                             <option value="Other">Other</option>
                             <option value="Power & Utilities">Power & Utilities</option>
                             <option value="Professional Services">Professional Services</option>
                             <option value="Real Estate & Construction">Real Estate & Construction</option>
                             <option value="Retail">Retail</option>
                             <option value="Software & Internet">Software & Internet</option>
                             <option value="Telecommunications">Telecommunications</option>
                             <option value="Transportation & Logistics">Transportation & Logistics</option>
                             <option value="Travel">Travel</option>
                             <option value="Wholesale & Distribution">Wholesale & Distribution</option>
                         </select>
                      </div></div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <div class="form-group">
                         <label for="company">Country <span>*</span></label>
                         <select class="form-control" name="country">
                      <option value="false">- select a country -</option>
                             <option value="US">United States</option>
                             <option value="AF">Afghanistan</option>
                             <option value="AL">Albania</option>
                             <option value="DZ">Algeria</option>
                             <option value="AS">American Samoa</option>
                             <option value="AD">Andorra</option>
                             <option value="AI">Anguilla</option>
                             <option value="AQ">Antarctica</option>
                             <option value="AG">Antigua</option>
                             <option value="AR">Argentina</option>
                             <option value="AM">Armenia</option>
                             <option value="AW">Aruba</option>
                             <option value="AU">Australia</option>
                             <option value="AT">Austria</option>
                             <option value="AZ">Azerbaijan</option>
                             <option value="BS">Bahamas</option>
                             <option value="BH">Bahrain</option>
                             <option value="BD">Bangladesh</option>
                             <option value="BB">Barbados</option>
                             <option value="BY">Belarus</option>
                             <option value="BZ">Belize</option>
                             <option value="BE">Belgium</option>
                             <option value="BJ">Benin</option>
                             <option value="BM">Bermuda</option>
                             <option value="BT">Bhutan</option>
                             <option value="BO">Bolivia</option>
                             <option value="BV">Bouvet Island</option>
                             <option value="BA">Bosnia &amp; Herzegovina</option>
                             <option value="BW">Botswana</option>
                             <option value="BR">Brazil</option>
                             <option value="IO">British Indian Ocean Territory</option>
                             <option value="BN">Brunei</option>
                             <option value="BG">Bulgaria</option>
                             <option value="BF">Burkina Faso</option>
                             <option value="BI">Burundi</option>
                             <option value="KH">Cambodia</option>
                             <option value="CM">Cameroon</option>
                             <option value="CA">Canada</option>
                             <option value="CV">Cape Verde</option>
                             <option value="KY">Cayman Islands</option>
                             <option value="CF">Central African Republic</option>
                             <option value="TD">Chad</option>
                             <option value="CL">Chile</option>
                             <option value="CN">China</option>
                             <option value="HK">Hong Kong</option>
                             <option value="MO">China (Macau S.A.R.)</option>
                             <option value="CX">Christmas Island</option>
                             <option value="CC">Cocos (Keeling) Islands</option>
                             <option value="CO">Colombia</option>
                             <option value="KM">Comoros</option>
                             <option value="CK">Cook Islands</option>
                             <option value="CR">Costa Rica</option>
                             <option value="CI">Cote D'Ivoire</option>
                             <option value="HR">Croatia</option>
                             <option value="CY">Cyprus</option>
                             <option value="CZ">Czech Republic</option>
                             <option value="CD">Democratic Republic of the Congo</option>
                             <option value="DK">Denmark</option>
                             <option value="DM">Dominica</option>
                             <option value="DO">Dominican Republic</option>
                             <option value="DJ">Djibouti</option>
                             <option value="TL">East Timor</option>
                             <option value="EC">Ecuador</option>
                             <option value="EG">Egypt</option>
                             <option value="SV">El Salvador</option>
                             <option value="GQ">Equatorial Guinea</option>
                             <option value="ER">Eritrea</option>
                             <option value="EE">Estonia</option>
                             <option value="ET">Ethiopia</option>
                             <option value="FK">Falkland Islands</option>
                             <option value="FO">Faroe Islands</option>
                             <option value="FJ">Fiji</option>
                             <option value="FI">Finland</option>
                             <option value="FR">France</option>
                             <option value="GF">French Guiana</option>
                             <option value="PF">French Polynesia</option>
                             <option value="TF">French Southern Territories</option>
                             <option value="MK">F.Y.R.O. Macedonia</option>
                             <option value="GA">Gabon</option>
                             <option value="GM">The Gambia</option>
                             <option value="GE">Georgia</option>
                             <option value="DE">Germany</option>
                             <option value="GH">Ghana</option>
                             <option value="GI">Gibraltar</option>
                             <option value="GR">Greece</option>
                             <option value="GL">Greenland</option>
                             <option value="GD">Grenada</option>
                             <option value="GP">Guadaloupe</option>
                             <option value="GU">Guam</option>
                             <option value="GT">Guatemala</option>
                             <option value="GN">Guinea</option>
                             <option value="GW">Guinea Bissau</option>
                             <option value="GY">Guyana</option>
                             <option value="HT">Haiti</option>
                             <option value="HM">Heard &amp; McDonald Islands</option>
                             <option value="HN">Honduras</option>
                             <option value="HU">Hungary</option>
                             <option value="IS">Iceland</option>
                             <option value="IN">India</option>
                             <option value="ID">Indonesia</option>
                             <option value="IE">Ireland</option>
                             <option value="IL">Israel</option>
                             <option value="IT">Italy</option>
                             <option value="JM">Jamaica</option>
                             <option value="JP">Japan</option>
                             <option value="JO">Jordan</option>
                             <option value="KZ">Kazakhstan</option>
                             <option value="KE">Kenya</option>
                             <option value="KI">Kiribati</option>
                             <option value="KR">Korea, South</option>
                             <option value="KW">Kuwait</option>
                             <option value="KG">Kyrgyzstan</option>
                             <option value="LA">Laos</option>
                             <option value="LV">Latvia</option>
                             <option value="LB">Lebanon</option>
                             <option value="LS">Lesotho</option>
                             <option value="LR">Liberia</option>
                             <option value="LI">Liechtenstein</option>
                             <option value="LT">Lithuania</option>
                             <option value="LU">Luxembourg</option>
                             <option value="MG">Madagascar</option>
                             <option value="MW">Malawi</option>
                             <option value="MY">Malaysia</option>
                             <option value="MV">Maldives</option>
                             <option value="ML">Mali</option>
                             <option value="MT">Malta</option>
                             <option value="MH">Marshall Islands</option>
                             <option value="MR">Mauritania</option>
                             <option value="MU">Mauritius</option>
                             <option value="MQ">Martinique</option>
                             <option value="YT">Mayotte</option>
                             <option value="MX">Mexico</option>
                             <option value="FM">Micronesia</option>
                             <option value="MD">Moldova</option>
                             <option value="MC">Monaco</option>
                             <option value="MN">Mongolia</option>
                             <option value="MS">Montserrat</option>
                             <option value="MA">Morocco</option>
                             <option value="MZ">Mozambique</option>
                             <option value="MM">Myanmar</option>
                             <option value="NA">Namibia</option>
                             <option value="NR">Nauru</option>
                             <option value="NP">Nepal</option>
                             <option value="NL">Netherlands</option>
                             <option value="AN">Netherlands Antilles</option>
                             <option value="NC">New Caledonia</option>
                             <option value="NZ">New Zealand</option>
                             <option value="NI">Nicaragua</option>
                             <option value="NE">Niger</option>
                             <option value="NG">Nigeria</option>
                             <option value="NU">Niue</option>
                             <option value="NO">Norway</option>
                             <option value="NF">Norfolk Island</option>
                             <option value="MP">Northern Mariana Islands</option>
                             <option value="OM">Oman</option>
                             <option value="PK">Pakistan</option>
                             <option value="PW">Palau</option>
                             <option value="PA">Panama</option>
                             <option value="PG">Papua New Guinea</option>
                             <option value="PY">Paraguay</option>
                             <option value="PE">Peru</option>
                             <option value="PH">Philippines</option>
                             <option value="PN">Pitcairn</option>
                             <option value="PL">Poland</option>
                             <option value="PT">Portugal</option>
                             <option value="PR">Puerto Rico</option>
                             <option value="QA">Qatar</option>
                             <option value="CG">Republic of the Congo</option>
                             <option value="RE">Reunion</option>
                             <option value="RO">Romania</option>
                             <option value="RU">Russia</option>
                             <option value="SH">Saint Helena</option>
                             <option value="KN">Saint Kitts</option>
                             <option value="LC">Saint Lucia</option>
                             <option value="PM">Saint Pierre</option>
                             <option value="VC">Saint Vincent</option>
                             <option value="WS">Samoa</option>
                             <option value="SM">San Marino</option>
                             <option value="ST">Sao Tome</option>
                             <option value="SA">Saudi Arabia</option>
                             <option value="SN">Senegal</option>
                             <option value="RS">Serbia</option>
                             <option value="SC">Seychelles</option>
                             <option value="SL">Sierra Leone</option>
                             <option value="SG">Singapore</option>
                             <option value="SK">Slovakia</option>
                             <option value="SI">Slovenia</option>
                             <option value="SB">Soloman Islands</option>
                             <option value="SO">Somalia</option>
                             <option value="ZA">South Africa</option>
                             <option value="GS">South Georgia &amp; South Sandwich Islands</option>
                             <option value="ES">Spain</option>
                             <option value="LK">Sri Lanka</option>
                             <option value="SR">Suriname</option>
                             <option value="SJ">Svalbard &amp; Jan Mayen Islands</option>
                             <option value="SZ">Swaziland</option>
                             <option value="SE">Sweden</option>
                             <option value="CH">Switzerland</option>
                             <option value="SY">Syria</option>
                             <option value="TW">Taiwan</option>
                             <option value="TJ">Tajikistan</option>
                             <option value="TZ">Tanzania</option>
                             <option value="TH">Thailand</option>
                             <option value="TG">Togo</option>
                             <option value="TK">Tokelau</option>
                             <option value="TO">Tonga</option>
                             <option value="TT">Trinidad &amp; Tobago</option>
                             <option value="TN">Tunisia</option>
                             <option value="TR">Turkey</option>
                             <option value="TC">Turks &amp; Caicos Islands</option>
                             <option value="TM">Turkmenistan</option>
                             <option value="TV">Tuvalu</option>
                             <option value="UG">Uganda</option>
                             <option value="UA">Ukraine</option>
                             <option value="AE">United Arab Emirates</option>
                             <option value="GB">United Kingdom</option>
                             <option value="UM">U.S. Minor Outlying Islands</option>
                             <option value="UY">Uruguay</option>
                             <option value="UZ">Uzbekistan</option>
                             <option value="VU">Vanuatu</option>
                             <option value="VA">Vatican City State</option>
                             <option value="VE">Venezuela</option>
                             <option value="VN">Vietnam</option>
                             <option value="VG">Virgin Islands (British)</option>
                             <option value="VI">Virgin Islands (US)</option>
                             <option value="WF">Wallis</option>
                             <option value="EH">Western Sahara</option>
                             <option value="YE">Yemen</option>
                             <option value="ZM">Zambia</option>
                             <option value="ZW">Zimbabwe</option>
                         </select>
                      </div></div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <div class="form-group">
                         <label for="state">State/Province <span>*</span></label>
                         <input type="text" class="form-control" id="state" name="state">
                      </div></div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <div class="form-group">
                         <label for="city">City <span>*</span></label>
                         <input type="text" class="form-control" id="city" name="city">
                      </div></div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <div class="form-group" >
                         <label for="postal">Postal Code <span>*</span></label>
                         <input type="text" class="form-control" id="postal_code" name="zip">
                      </div></div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                       <div class="form-group">
                         <label for="jobrole">Level of AWS Usage <span>*</span></label>
                         <select class="form-control" name="aws_usage_level" >
                            <option>---- Select ----</option>
                            <option value="AWS Usage Level1">AWS Usage Level1</option>
                            <option value="AWS Usage Level2">AWS Usage Level2</option>
                         </select>
                      </div></div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <div class="form-group">
                         <label for="jobrole">Use Case<span>*</span></label>
                         <select class="form-control" name="use_case">
                            <option>---- Select ----</option>
                            <option value="Use case1">Use case1</option>
                            <option value="Use case2">Use case2</option>
                         </select>
                      </div></div> -->
                   <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div class="form-group">
                         <label for="jobrole">Tell us about your project<span>*</span></label>
                         <textarea class="form-control" rows="4" [(ngModel)]="customerData.About"></textarea>
                      </div>
                   </div>
                   <!--
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div class="form-group">
                         <label for="jobrole">I am completing this form in connection with my  <span>*</span></label>
                         <div class="custom-control custom-radio">
                            <input type="radio" class="custom-control-input" id="customRadio" name="connection_with" value="Business Interest1">
                            <label class="custom-control-label" for="customRadio">Business Interest1</label>
                         </div>
                         <div class="custom-control custom-radio">
                            <input type="radio" class="custom-control-input" id="customRadio2" name="connection_with" value="Business Interest2">
                            <label class="custom-control-label" for="customRadio2">Business Interest2</label>
                         </div>
                      </div></div>
                      -->
                   <p style="margin-top: 20px; margin:0 auto;">
                      <button type="submit"  (click)="sendUserDetails()" class="button special" id="get_report" data-validator="validateStepOne">Get Report</button>
                   </p>
                </div>
          </div>
       </div>
    </div>
 </div>